export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: string;
  File: any;
  JSON: any;
  Upload: any;
};

export type AccessCard = {
  __typename?: 'AccessCard';
  accesslist?: Maybe<Accesslist>;
  cardName?: Maybe<Scalars['String']>;
  cardnumber: Scalars['String'];
  id: Scalars['ID'];
  lockedLockers?: Maybe<Array<Maybe<Locker>>>;
  name?: Maybe<Scalars['String']>;
  validityEnd?: Maybe<Scalars['DateTime']>;
  validityStart?: Maybe<Scalars['DateTime']>;
};


export type AccessCardLockedLockersArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
};

export type AccessCardValidiesConnection = {
  __typename?: 'AccessCardValidiesConnection';
  accessCards?: Maybe<Array<Maybe<AccessCard>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccessGroup = {
  __typename?: 'AccessGroup';
  accesslistHasAccess?: Maybe<Scalars['Boolean']>;
  allowLockAll: Scalars['Boolean'];
  canPreventOpening: Scalars['Boolean'];
  id: Scalars['ID'];
  lockers: Array<Locker>;
  lockersystem?: Maybe<Lockersystem>;
  maxLockedPerCard: Scalars['Int'];
  name: Scalars['String'];
  requireLockerPerm: Scalars['Boolean'];
};


export type AccessGroupAccesslistHasAccessArgs = {
  accesslistId: Scalars['ID'];
};

export type AccessGroupAccess = {
  __typename?: 'AccessGroupAccess';
  accessGroup?: Maybe<AccessGroup>;
  accessGroupId?: Maybe<Scalars['ID']>;
  accesslist?: Maybe<Accesslist>;
  accesslistId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  master: Scalars['Boolean'];
};

export type AccessGroupLocker = {
  __typename?: 'AccessGroupLocker';
  id: Scalars['ID'];
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  name: Scalars['Int'];
};

export type AccessGroupLockersConnection = {
  __typename?: 'AccessGroupLockersConnection';
  lockers: Array<AccessGroupLocker>;
  totalCount: Scalars['Int'];
};

export type AccessGroupsConnection = {
  __typename?: 'AccessGroupsConnection';
  accessGroups: Array<AccessGroup>;
};

export enum AccessType {
  KeepLockOpen = 'KeepLockOpen',
  Locking = 'Locking',
  OpenDiffCard = 'OpenDiffCard',
  Opening = 'Opening',
  Unknown = 'Unknown'
}

export type Accesslist = {
  __typename?: 'Accesslist';
  accessCards: Array<AccessCard>;
  accessGroupAccesses: Array<AccessGroupAccess>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};


export type AccesslistAccessCardsArgs = {
  cardnumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
};

export type AccesslistChange = {
  __typename?: 'AccesslistChange';
  accesslist?: Maybe<Accesslist>;
  card?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<AccesslistChangeType>;
};

export enum AccesslistChangeType {
  AccessGroupRemoved = 'AccessGroupRemoved',
  AccessGroupUpdated = 'AccessGroupUpdated',
  AccesslistRemoved = 'AccesslistRemoved',
  AccesslistUpdated = 'AccesslistUpdated',
  AddCardToAccesslist = 'AddCardToAccesslist',
  ExpireAccesslistCard = 'ExpireAccesslistCard',
  RemCardToAccesslist = 'RemCardToAccesslist'
}

export type AccesslistUsersConnection = {
  __typename?: 'AccesslistUsersConnection';
  totalCount?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type AccesslistsConnection = {
  __typename?: 'AccesslistsConnection';
  accesslists: Array<Accesslist>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AddAccessGroupAccess = {
  accessGroupId: Scalars['ID'];
  accesslistId: Scalars['ID'];
  master: Scalars['Boolean'];
};

export type AddAccessGroupAccessForAccesslist = {
  accessGroupId: Scalars['ID'];
  accesslistId: Scalars['ID'];
  master: Scalars['Boolean'];
};

export type AddAccessGroupAccessResponse = {
  __typename?: 'AddAccessGroupAccessResponse';
  accessGroupAccess?: Maybe<AccessGroupAccess>;
};

export type AddGateToGateGroupResponse = {
  __typename?: 'AddGateToGateGroupResponse';
  gate: Gate;
  gateGroup: GateGroup;
  success: Scalars['Boolean'];
};

export type AddLockerToGroup = {
  lockerGroupId: Scalars['ID'];
  lockerId: Scalars['ID'];
};

export type AddLockersToAccessGroupResponse = {
  __typename?: 'AddLockersToAccessGroupResponse';
  accessGroupLockers: Array<AccessGroupLocker>;
  success: Scalars['Boolean'];
};

export type AddLockersToLockerGroup = {
  lockerGroupId: Scalars['ID'];
  lockerIds: Array<Scalars['ID']>;
};

export type AddLockersToLockerGroupResponse = {
  __typename?: 'AddLockersToLockerGroupResponse';
  lockerGroup?: Maybe<LockerGroup>;
};

export type AddLockersystemPermissionForUser = {
  admin?: InputMaybe<Scalars['Boolean']>;
  lockersystemId: Scalars['ID'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type AddLockersystemPermissionForUserResponse = {
  __typename?: 'AddLockersystemPermissionForUserResponse';
  lockersystem?: Maybe<Lockersystem>;
  lockersystemUserPermission?: Maybe<LockersystemUserPermission>;
  user?: Maybe<User>;
};

export type AddPanelNoteInput = {
  note: Scalars['String'];
  panelId: Scalars['ID'];
};

export type AddPanelNoteResponse = {
  __typename?: 'AddPanelNoteResponse';
  note: PanelNote;
};

export type AddUserDoorcontrolPermission = {
  canCalibrateLockers?: InputMaybe<Scalars['Boolean']>;
  canChangeNode?: InputMaybe<Scalars['Boolean']>;
  canRemoteOpen?: InputMaybe<Scalars['Boolean']>;
  canSendCardKeys?: InputMaybe<Scalars['Boolean']>;
  canSendDoormap?: InputMaybe<Scalars['Boolean']>;
  canSetHallTestMode?: InputMaybe<Scalars['Boolean']>;
  canViewDoorState?: InputMaybe<Scalars['Boolean']>;
  doorcontrolDeviceNumber: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AddUserDoorcontrolPermissionResponse = {
  __typename?: 'AddUserDoorcontrolPermissionResponse';
  userDoorcontrolPermission?: Maybe<UserDoorcontrolPermission>;
};

export type AddUserGroupLockersystemPermission = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  lockersystemId: Scalars['ID'];
  role: LockersystemRole;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  userGroupId: Scalars['ID'];
};

export type AddUserGroupLockersystemPermissionResponse = {
  __typename?: 'AddUserGroupLockersystemPermissionResponse';
  userGroupLockersystemPermission: UserGroupLockersystemPermission;
};

export type AddUserLockerPermission = {
  lockerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AddUserLockerPermissionResponse = {
  __typename?: 'AddUserLockerPermissionResponse';
  userLockerPermission?: Maybe<UserLockerPermission>;
};

export type AddUserToAccesslist = {
  accesslistId: Scalars['ID'];
  cardName?: InputMaybe<Scalars['String']>;
  cardnumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  validityEnd?: InputMaybe<Scalars['DateTime']>;
  validityStart?: InputMaybe<Scalars['DateTime']>;
};

export type AddUserToAccesslistResponse = {
  __typename?: 'AddUserToAccesslistResponse';
  accessCard?: Maybe<AccessCard>;
  accesslist?: Maybe<Accesslist>;
  user?: Maybe<User>;
};

export type AllAccessGroupsConnection = {
  __typename?: 'AllAccessGroupsConnection';
  accessGroups?: Maybe<Array<Maybe<AccessGroup>>>;
};

export type AllowLockersystemAccess = {
  lockersystemId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AllowLockersystemAccessResponse = {
  __typename?: 'AllowLockersystemAccessResponse';
  permission?: Maybe<LockersystemUserPermission>;
};

export type AllowRenting = {
  email?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  rentingUserId?: InputMaybe<Scalars['ID']>;
  returnItemBefore?: InputMaybe<Scalars['DateTime']>;
};

export type AllowRentingResponse = {
  __typename?: 'AllowRentingResponse';
  renting?: Maybe<Renting>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['ID'];
  lastUsage?: Maybe<Scalars['String']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
};

export enum ApiPermission {
  FetchAccessCardUsers = 'FETCH_ACCESS_CARD_USERS',
  SyncAllAccessCardUsers = 'SYNC_ALL_ACCESS_CARD_USERS',
  SyncCurrentAccessCardUsers = 'SYNC_CURRENT_ACCESS_CARD_USERS'
}

export type AreaState = {
  __typename?: 'AreaState';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  counter?: Maybe<Scalars['Int']>;
};

export enum AudioModeCmd {
  Alarm = 'Alarm',
  Cancel = 'Cancel'
}

export type BeginPasskeyLoginResponse = {
  __typename?: 'BeginPasskeyLoginResponse';
  challengeId: Scalars['ID'];
  options: Scalars['JSON'];
};

export type BeginPasskeyRegistrationInput = {
  label: Scalars['String'];
};

export type BeginPasskeyRegistrationResponse = {
  __typename?: 'BeginPasskeyRegistrationResponse';
  challengeId: Scalars['ID'];
  options: Scalars['JSON'];
};

export type BlockDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type BlockDoorcontrolResponse = {
  __typename?: 'BlockDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type BreakInAlarm = {
  __typename?: 'BreakInAlarm';
  companyId?: Maybe<Scalars['ID']>;
  locker?: Maybe<Locker>;
  lockerId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type CalibrateLockers = {
  cmd: CalibrationCmd;
  deviceNumber: Scalars['String'];
  lockerNumbers: Array<Scalars['Int']>;
  pulses?: InputMaybe<Array<Scalars['Int']>>;
};

export type CalibrateLockersResponse = {
  __typename?: 'CalibrateLockersResponse';
  status?: Maybe<CommandStatus>;
};

export enum CalibrationCmd {
  Calibrate = 'Calibrate',
  Cancel = 'Cancel',
  FactoryReset = 'FactoryReset',
  FetchPulses = 'FetchPulses',
  SetPulses = 'SetPulses'
}

export type CanDoor = {
  __typename?: 'CanDoor';
  alarm?: Maybe<Scalars['Boolean']>;
  calibrating?: Maybe<Scalars['Boolean']>;
  door?: Maybe<Scalars['Int']>;
  hallSensorActive?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  node?: Maybe<Scalars['Int']>;
  outOfOrder?: Maybe<Scalars['Boolean']>;
  stuck?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type CanNode = {
  __typename?: 'CanNode';
  access?: Maybe<Scalars['Boolean']>;
  darkmode?: Maybe<Scalars['Boolean']>;
  demo?: Maybe<Scalars['Boolean']>;
  desfire?: Maybe<Scalars['Boolean']>;
  doubleLock?: Maybe<Scalars['Boolean']>;
  fastAlarm?: Maybe<Scalars['Boolean']>;
  hid?: Maybe<Scalars['Boolean']>;
  hslDesfire?: Maybe<Scalars['Boolean']>;
  keepLock?: Maybe<Scalars['Boolean']>;
  kela?: Maybe<Scalars['Boolean']>;
  keyACrc?: Maybe<Scalars['Int']>;
  keyBCrc?: Maybe<Scalars['Int']>;
  leftOpen?: Maybe<Scalars['Boolean']>;
  masterWhitelistVersion?: Maybe<Scalars['Int']>;
  mifare?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['Boolean']>;
  multiuse?: Maybe<Scalars['Boolean']>;
  node?: Maybe<Scalars['Int']>;
  nodeChangeAllowed?: Maybe<Scalars['Boolean']>;
  nodeSetWithDip?: Maybe<Scalars['Boolean']>;
  outOfOrder?: Maybe<Scalars['Boolean']>;
  panel?: Maybe<Scalars['String']>;
  parametersOk?: Maybe<Scalars['Boolean']>;
  personal?: Maybe<Scalars['Boolean']>;
  rightOpen?: Maybe<Scalars['Boolean']>;
  segment?: Maybe<Scalars['Int']>;
  serials?: Maybe<Array<Maybe<Scalars['String']>>>;
  silent?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  ultralight?: Maybe<Scalars['Boolean']>;
  upperMotorDetected?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type CanbusChange = {
  __typename?: 'CanbusChange';
  canbusConnected?: Maybe<Scalars['Boolean']>;
  deviceNumber?: Maybe<Scalars['String']>;
  doors?: Maybe<Array<Maybe<CanDoor>>>;
  nodes?: Maybe<Array<Maybe<CanNode>>>;
  removedNodes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updateEtaSeconds?: Maybe<Scalars['Int']>;
  updatePercent?: Maybe<Scalars['Int']>;
  updateStopped?: Maybe<Scalars['Boolean']>;
};

export type CanbusMessage = {
  __typename?: 'CanbusMessage';
  canId: Scalars['Int'];
  data: Array<Scalars['Int']>;
  deviceNumber: Scalars['String'];
  direction: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type CancelJobResponse = {
  __typename?: 'CancelJobResponse';
  job: Job;
};

export enum CancelReason {
  AdminCancelled = 'AdminCancelled',
  DoorNotPropelyLocked = 'DoorNotPropelyLocked',
  DoorhubCancelled = 'DoorhubCancelled',
  DoorhubHasReservationButNotLocked = 'DoorhubHasReservationButNotLocked',
  NewReservationWithSameDoor = 'NewReservationWithSameDoor',
  PreauthFailed = 'PreauthFailed',
  PreauthTimeout = 'PreauthTimeout',
  TryingToReserveWithRead = 'TryingToReserveWithRead',
  Unknown = 'Unknown',
  UserCancelled = 'UserCancelled'
}

export type CancelRenting = {
  rentingId: Scalars['ID'];
};

export type CancelRentingResponse = {
  __typename?: 'CancelRentingResponse';
  reting?: Maybe<Renting>;
};

export type CancelScheduledLockerProgramUpdate = {
  scheduledLockerProgramUpdateId: Scalars['ID'];
};

export type CancelScheduledLockerProgramUpdateResponse = {
  __typename?: 'CancelScheduledLockerProgramUpdateResponse';
  scheduledLockerProgramUpdate?: Maybe<ScheduledLockerProgramUpdate>;
};

export type CardKey = {
  __typename?: 'CardKey';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ChangeLanguage = {
  language: Scalars['String'];
  userId: Scalars['ID'];
};

export type ChangeLanguageResponse = {
  __typename?: 'ChangeLanguageResponse';
  user?: Maybe<User>;
};

export type ChangeNode = {
  deviceNumber: Scalars['String'];
  newNode: Scalars['Int'];
  node: Scalars['Int'];
};

export type ChangeNodeResponse = {
  __typename?: 'ChangeNodeResponse';
  status?: Maybe<CommandStatus>;
};

export type ChangeUserPassword = {
  newPassword: Scalars['String'];
  userId: Scalars['ID'];
};

export type ChangeUserPasswordResponse = {
  __typename?: 'ChangeUserPasswordResponse';
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type CheckRentingCodeResponse = {
  __typename?: 'CheckRentingCodeResponse';
  lockerNumber?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CheckRentingReturnCode = {
  __typename?: 'CheckRentingReturnCode';
  lockerNumber?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CheckSeitaUpdates = {
  deviceNumber: Scalars['String'];
};

export type CheckSeitaUpdatesResponse = {
  __typename?: 'CheckSeitaUpdatesResponse';
  reboot?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status?: Maybe<CommandStatus>;
};

export type ClearLockersystemHistory = {
  lockersystemId: Scalars['ID'];
};

export type ClearLockersystemHistoryResponse = {
  __typename?: 'ClearLockersystemHistoryResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type ClearLockersystemState = {
  lockersystemId: Scalars['ID'];
};

export type ClearLockersystemStateResponse = {
  __typename?: 'ClearLockersystemStateResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type CloseSales = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  gateId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['ID']>;
};

export type CloseSalesResponse = {
  __typename?: 'CloseSalesResponse';
  affectedNodes?: Maybe<Scalars['Int']>;
  nodes: Array<GateNode>;
};

export type Cluster = {
  __typename?: 'Cluster';
  clusterName?: Maybe<Scalars['String']>;
  clusterState?: Maybe<ClusterState>;
  environmentId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  lockedLockersCount?: Maybe<Scalars['Int']>;
  lockers: Array<Locker>;
  lockersCount?: Maybe<Scalars['Int']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  onlineLockersCount?: Maybe<Scalars['Int']>;
  openLockersCount?: Maybe<Scalars['Int']>;
};

export enum ClusterState {
  All = 'ALL',
  Configured = 'CONFIGURED',
  NotConfigured = 'NOT_CONFIGURED'
}

export enum CommandStatus {
  Delivered = 'Delivered',
  Offline = 'Offline'
}

export type CompanyGateState = {
  __typename?: 'CompanyGateState';
  areaStates: Array<AreaState>;
  companyId: Scalars['ID'];
  companyName?: Maybe<Scalars['String']>;
  counter?: Maybe<Scalars['Int']>;
  gateStates: Array<GateState>;
  nodeStates: Array<GateNode>;
};

export type CompanyLockersystemChange = {
  __typename?: 'CompanyLockersystemChange';
  lockerGroups: Array<LockerGroup>;
  lockers: Array<Locker>;
  lockersystem: Lockersystem;
};

export type ConfigureLockerNodes = {
  deviceNumber: Scalars['String'];
  nodes: Array<ConfigureNode>;
};

export type ConfigureLockerNodesResponse = {
  __typename?: 'ConfigureLockerNodesResponse';
  status?: Maybe<CommandStatus>;
};

export type ConfigureNode = {
  access?: InputMaybe<Scalars['Boolean']>;
  darkmode?: InputMaybe<Scalars['Boolean']>;
  demo?: InputMaybe<Scalars['Boolean']>;
  desfire?: InputMaybe<Scalars['Boolean']>;
  fastAlarm?: InputMaybe<Scalars['Boolean']>;
  hid?: InputMaybe<Scalars['Boolean']>;
  hslDesfire?: InputMaybe<Scalars['Boolean']>;
  keeplock?: InputMaybe<Scalars['Boolean']>;
  keyCheck?: InputMaybe<Scalars['Boolean']>;
  leftDownLocker?: InputMaybe<Scalars['Int']>;
  leftOpen?: InputMaybe<Scalars['Boolean']>;
  leftUpLocker?: InputMaybe<Scalars['Int']>;
  mifare?: InputMaybe<Scalars['Boolean']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  multiuse?: InputMaybe<Scalars['Boolean']>;
  node: Scalars['Int'];
  personal?: InputMaybe<Scalars['Boolean']>;
  rightDownLocker?: InputMaybe<Scalars['Int']>;
  rightOpen?: InputMaybe<Scalars['Boolean']>;
  rightUpLocker?: InputMaybe<Scalars['Int']>;
  segment: Scalars['Int'];
  silent?: InputMaybe<Scalars['Boolean']>;
  sote?: InputMaybe<Scalars['Boolean']>;
  ultralight?: InputMaybe<Scalars['Boolean']>;
  verticalDoubleLock?: InputMaybe<Scalars['Boolean']>;
};

export type ConnectDoorcontrolToLockersystem = {
  clusterId: Scalars['ID'];
  deviceNumber: Scalars['ID'];
};

export type ConnectDoorcontrolToLockersystemResponse = {
  __typename?: 'ConnectDoorcontrolToLockersystemResponse';
  cluster?: Maybe<Cluster>;
  doorcontrol?: Maybe<Doorcontrol>;
};

export type CopyItem = {
  itemId: Scalars['ID'];
};

export type CopyItemResponse = {
  __typename?: 'CopyItemResponse';
  item?: Maybe<Item>;
};

export enum CostGapType {
  Day = 'Day',
  Duration = 'Duration',
  None = 'None'
}

export type CostTable = {
  __typename?: 'CostTable';
  entries: Array<CostTableEntry>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CostTableEntry = {
  __typename?: 'CostTableEntry';
  cost: Scalars['Int'];
  id: Scalars['ID'];
  seconds: Scalars['Int'];
};

export type CostTableEntryInput = {
  cost: Scalars['Int'];
  seconds: Scalars['Int'];
};

export type CreateAccessGroup = {
  lockersystemId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateAccessGroupResponse = {
  __typename?: 'CreateAccessGroupResponse';
  accessGroup: AccessGroup;
};

export type CreateAccesslist = {
  lockersystemId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateAccesslistResponse = {
  __typename?: 'CreateAccesslistResponse';
  accesslist: Accesslist;
};

export type CreateCardKeys = {
  keysdat: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCardKeysResponse = {
  __typename?: 'CreateCardKeysResponse';
  cardKey?: Maybe<CardKey>;
};

export type CreateCostTable = {
  entries: Array<CostTableEntryInput>;
  name: Scalars['String'];
};

export type CreateCostTableResponse = {
  __typename?: 'CreateCostTableResponse';
  costTable?: Maybe<CostTable>;
};

export type CreateDataExportJobInput = {
  dataExport?: InputMaybe<DataExportDatasetInput>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  jobType: JobType;
  lockersystemIds?: InputMaybe<Array<Scalars['ID']>>;
  maintenanceReport?: InputMaybe<MaintenanceReportInput>;
  recipientUserIds?: InputMaybe<Array<Scalars['ID']>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type CreateDataExportJobResponse = {
  __typename?: 'CreateDataExportJobResponse';
  job: Job;
};

export type CreateDeviceGate = {
  areaId: Scalars['String'];
  companyId: Scalars['String'];
  deviceNumber: Scalars['ID'];
  gateId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type CreateDeviceGateResponse = {
  __typename?: 'CreateDeviceGateResponse';
  deviceGate: DeviceGate;
};

export type CreateGateGroupResponse = {
  __typename?: 'CreateGateGroupResponse';
  gateGroup?: Maybe<GateGroup>;
  success: Scalars['Boolean'];
};

export type CreateItem = {
  description?: InputMaybe<Scalars['String']>;
  emailAdminWhenReturned?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['Upload']>;
  itemGroupId?: InputMaybe<Scalars['ID']>;
  lockersystemId: Scalars['ID'];
  name: Scalars['String'];
  needsPermit?: InputMaybe<Scalars['Boolean']>;
  rentable?: InputMaybe<Scalars['Boolean']>;
  rentingMaxTime?: InputMaybe<Scalars['Int']>;
};

export type CreateItemGroup = {
  lockersystemId: Scalars['ID'];
  maxRentingsPerUser?: InputMaybe<Scalars['Int']>;
  maxRentingsPerUserEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentItemGroupId?: InputMaybe<Scalars['ID']>;
};

export type CreateItemGroupResponse = {
  __typename?: 'CreateItemGroupResponse';
  itemGroup?: Maybe<ItemGroup>;
};

export type CreateItemResponse = {
  __typename?: 'CreateItemResponse';
  code?: Maybe<Scalars['String']>;
  item?: Maybe<Item>;
};

export type CreateLockerEventInput = {
  boardId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  type: LockerEventType;
};

export type CreateLockerEventResponse = {
  __typename?: 'CreateLockerEventResponse';
  event: LockerEvent;
};

export type CreateLockerGroup = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  lainaamo?: InputMaybe<Scalars['Boolean']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockersystemId: Scalars['ID'];
  name: Scalars['String'];
  parentLockerGroupId?: InputMaybe<Scalars['ID']>;
};

export type CreateLockerGroupResponse = {
  __typename?: 'CreateLockerGroupResponse';
  lockerGroup?: Maybe<LockerGroup>;
  lockersystem?: Maybe<Lockersystem>;
};

export type CreateLockerProgramLabel = {
  description?: InputMaybe<Scalars['String']>;
  lockerProgramId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateLockerProgramLabelResponse = {
  __typename?: 'CreateLockerProgramLabelResponse';
  lockerProgramLabel?: Maybe<LockerProgramLabel>;
};

export type CreateLockersystem = {
  name: Scalars['String'];
};

export type CreateLockersystemResponse = {
  __typename?: 'CreateLockersystemResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type CreateResetTokenResponse = {
  __typename?: 'CreateResetTokenResponse';
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type CreateScheduledLockerProgramUpdate = {
  bitrate: Scalars['Int'];
  deviceNumber: Scalars['String'];
  lockerProgramId: Scalars['ID'];
  scheduledAt: Scalars['DateTime'];
};

export type CreateScheduledLockerProgramUpdateResponse = {
  __typename?: 'CreateScheduledLockerProgramUpdateResponse';
  scheduledLockerProgramUpdate?: Maybe<ScheduledLockerProgramUpdate>;
};

export type CreateTokenFromPortalOauthCode = {
  code: Scalars['String'];
};

export type CreateTokenFromPortalOauthCodeResponse = {
  __typename?: 'CreateTokenFromPortalOauthCodeResponse';
  token?: Maybe<Scalars['String']>;
};

export type CreateTokenResponse = {
  __typename?: 'CreateTokenResponse';
  token?: Maybe<Scalars['String']>;
};

export type CreateUser = {
  userName: Scalars['String'];
};

export type CreateUserGroup = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateUserGroupResponse = {
  __typename?: 'CreateUserGroupResponse';
  userGroup: UserGroup;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  user?: Maybe<User>;
};

export type DailyAdminCode = {
  __typename?: 'DailyAdminCode';
  code?: Maybe<Scalars['String']>;
  deviceNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export enum DashboardLayoutType {
  Lainaamo = 'LAINAAMO',
  Sairaala = 'SAIRAALA',
  Tavaransailytys = 'TAVARANSAILYTYS',
  Uimahalli = 'UIMAHALLI',
  Unassigned = 'UNASSIGNED'
}

export type DataExportDatasetInput = {
  doorNoteFields?: InputMaybe<Array<Scalars['String']>>;
  gateEventCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  gateEventFields?: InputMaybe<Array<Scalars['String']>>;
  gateEventTypes?: InputMaybe<Array<GateNodeEventType>>;
  includeDoorNotes?: InputMaybe<Scalars['Boolean']>;
  includeGateEvents?: InputMaybe<Scalars['Boolean']>;
  includeLockerAccessFeedbacks?: InputMaybe<Scalars['Boolean']>;
  includeLockerHistory?: InputMaybe<Scalars['Boolean']>;
  lockerAccessFeedbackFields?: InputMaybe<Array<Scalars['String']>>;
  lockerHistoryFields?: InputMaybe<Array<Scalars['String']>>;
};

export type DatetimeDataPoint = {
  __typename?: 'DatetimeDataPoint';
  datetime: Scalars['DateTime'];
  inCount: Scalars['Int'];
  outCount: Scalars['Int'];
};

export type DeclineDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type DeclineDoorcontrolResponse = {
  __typename?: 'DeclineDoorcontrolResponse';
  cluster?: Maybe<Cluster>;
  doorcontrol?: Maybe<Doorcontrol>;
};

export type DeclinePermit = {
  rentingId: Scalars['ID'];
};

export type DeclinePermitResponse = {
  __typename?: 'DeclinePermitResponse';
  renting: Renting;
};

export type DeleteAccessCardUser = {
  accesslistId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteAccessCardUserResponse = {
  __typename?: 'DeleteAccessCardUserResponse';
  accesslist?: Maybe<Accesslist>;
};

export type DeleteCardKeys = {
  id: Scalars['ID'];
};

export type DeleteCardKeysResponse = {
  __typename?: 'DeleteCardKeysResponse';
  id: Scalars['ID'];
};

export type DeleteDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type DeleteDoorcontrolResponse = {
  __typename?: 'DeleteDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type DeleteItem = {
  itemId: Scalars['ID'];
};

export type DeleteItemGroup = {
  id: Scalars['ID'];
};

export type DeleteItemGroupResponse = {
  __typename?: 'DeleteItemGroupResponse';
  itemGroupId?: Maybe<Scalars['ID']>;
};

export type DeleteItemResponse = {
  __typename?: 'DeleteItemResponse';
  item: Item;
};

export type DeleteJobResponse = {
  __typename?: 'DeleteJobResponse';
  jobId: Scalars['ID'];
};

export type DeleteLockerProgram = {
  lockerProgramId: Scalars['ID'];
};

export type DeleteLockerProgramLabel = {
  lockerProgramLabelId: Scalars['ID'];
};

export type DeleteLockerProgramLabelResponse = {
  __typename?: 'DeleteLockerProgramLabelResponse';
  lockerProgramLabelId?: Maybe<Scalars['ID']>;
};

export type DeleteLockerProgramResponse = {
  __typename?: 'DeleteLockerProgramResponse';
  lockerProgramId?: Maybe<Scalars['ID']>;
};

export type DeleteMasterCardInput = {
  masterCardId: Scalars['ID'];
};

export type DeliverItemToUser = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  identityCode?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['Upload']>;
  lockerId: Scalars['ID'];
  pickupBefore: Scalars['DateTime'];
  userGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DeliverItemToUserResponse = {
  __typename?: 'DeliverItemToUserResponse';
  code: Scalars['String'];
  delivery: Delivery;
  locker: Locker;
};

export type DeliveriesConnection = {
  __typename?: 'DeliveriesConnection';
  deliveries: Array<Delivery>;
};

export type Delivery = {
  __typename?: 'Delivery';
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryCode?: Maybe<Scalars['String']>;
  deliveryCodeUsedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageFileId?: Maybe<Scalars['ID']>;
  interruptCode?: Maybe<Scalars['String']>;
  interruptCodeUsedAt?: Maybe<Scalars['DateTime']>;
  locker?: Maybe<Locker>;
  pickupBefore?: Maybe<Scalars['DateTime']>;
  pickupCode?: Maybe<Scalars['String']>;
  pickupCodeUsedAt?: Maybe<Scalars['DateTime']>;
  pickupUser?: Maybe<User>;
  reverseDelivery: Scalars['Boolean'];
  useDeliveryCodeBefore?: Maybe<Scalars['DateTime']>;
  useInterruptCodeBefore?: Maybe<Scalars['DateTime']>;
  usePickupCodeBefore?: Maybe<Scalars['DateTime']>;
  userDeliveredId?: Maybe<Scalars['String']>;
  userWhoDelivered?: Maybe<User>;
  whoCanPickup: Array<User>;
};

export enum DeliveryState {
  Late = 'Late'
}

export type DenyLockersystemAccess = {
  lockersystemId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DenyLockersystemAccessResponse = {
  __typename?: 'DenyLockersystemAccessResponse';
  permission?: Maybe<LockersystemUserPermission>;
};

export type DeviceGate = {
  __typename?: 'DeviceGate';
  areaId: Scalars['String'];
  companyId: Scalars['String'];
  deviceId: Scalars['ID'];
  gateId: Scalars['String'];
  id: Scalars['ID'];
  nodeId: Scalars['String'];
};

export type DisconnectDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type DisconnectDoorcontrolResponse = {
  __typename?: 'DisconnectDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type DoorAccessLocking = {
  __typename?: 'DoorAccessLocking';
  card: Scalars['String'];
  deviceNumber: Scalars['String'];
  lockerNumber: Scalars['Int'];
  lockerSeq: Scalars['Int'];
};

export type DoorAccessLockingResponseInput = {
  card: Scalars['String'];
  deviceNumber: Scalars['ID'];
  lockerNumber: Scalars['Int'];
  lockingAllowed: Scalars['Boolean'];
  master?: InputMaybe<Scalars['Boolean']>;
};

export type DoorAccessOpening = {
  __typename?: 'DoorAccessOpening';
  card: Scalars['String'];
  deviceNumber: Scalars['String'];
  lockerNumber: Scalars['Int'];
  lockerSeq: Scalars['Int'];
};

export type DoorAccessOpeningResponseInput = {
  card: Scalars['String'];
  deviceNumber: Scalars['ID'];
  lockerNumber: Scalars['Int'];
  master?: InputMaybe<Scalars['Boolean']>;
  openingAllowed: Scalars['Boolean'];
  release?: InputMaybe<Scalars['Boolean']>;
};

export type DoorAccessResponse = {
  __typename?: 'DoorAccessResponse';
  status?: Maybe<CommandStatus>;
};

export type DoorNote = {
  __typename?: 'DoorNote';
  door?: Maybe<Scalars['Int']>;
  doorcontrol?: Maybe<Doorcontrol>;
  doorcontrolId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  noteType?: Maybe<DoorNoteType>;
  serialNumber?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  val1?: Maybe<Scalars['Int']>;
  val2?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export enum DoorNoteType {
  BuzzerModeChanged = 'BuzzerModeChanged',
  CalibrationEnd = 'CalibrationEnd',
  CanRecoverCounter = 'CanRecoverCounter',
  HallSensorStateChange = 'HallSensorStateChange',
  KeymasterNotAllowed = 'KeymasterNotAllowed',
  MsgCheckFail = 'MsgCheckFail',
  MsgLengthFail = 'MsgLengthFail',
  MsgSegmentFail = 'MsgSegmentFail',
  MsgTimeFail = 'MsgTimeFail',
  NoSegmentation = 'NoSegmentation',
  NoTimeSync = 'NoTimeSync',
  NodeChangeNotAllowed = 'NodeChangeNotAllowed',
  OptoLower = 'OptoLower',
  OptoUpper = 'OptoUpper',
  OutOfOrderStateChanged = 'OutOfOrderStateChanged',
  TimeReqNotValid = 'TimeReqNotValid',
  Unknown = 'Unknown',
  WrongLockUid = 'WrongLockUid'
}

export type DoorNotesQuery = {
  doorcontrolId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  noteTypes?: InputMaybe<Array<InputMaybe<DoorNoteType>>>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type Doorcontrol = {
  __typename?: 'Doorcontrol';
  adminMenuPassword?: Maybe<Scalars['String']>;
  adminMenuVisible?: Maybe<Scalars['Boolean']>;
  barcodeEnabled?: Maybe<Scalars['Boolean']>;
  barcodePort?: Maybe<Scalars['String']>;
  barcodeReaders: Array<Scalars['String']>;
  block?: Maybe<Scalars['Boolean']>;
  canbridgeUsed?: Maybe<Scalars['Boolean']>;
  canbusConnected?: Maybe<Scalars['Boolean']>;
  canbusEnabled?: Maybe<Scalars['Boolean']>;
  cardKeysId?: Maybe<Scalars['ID']>;
  cluster?: Maybe<Cluster>;
  companyId?: Maybe<Scalars['ID']>;
  connectionEnd?: Maybe<Scalars['DateTime']>;
  connectionStart?: Maybe<Scalars['DateTime']>;
  connectionUserType?: Maybe<DoorcontrolConnectionUserType>;
  costGapType?: Maybe<CostGapType>;
  costGapValue?: Maybe<Scalars['Int']>;
  costTable?: Maybe<CostTable>;
  debugMode?: Maybe<Scalars['Boolean']>;
  deviceNumber?: Maybe<Scalars['String']>;
  disconnectCountToday?: Maybe<Scalars['Int']>;
  guiMode?: Maybe<GuiMode>;
  hide?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  latestBarcodeRead?: Maybe<Scalars['String']>;
  latestReservationHour?: Maybe<Scalars['Int']>;
  latestReservationMinute?: Maybe<Scalars['Int']>;
  localApiEnabled?: Maybe<LocalApiEnabled>;
  loglevel?: Maybe<Loglevel>;
  maxReservationTime?: Maybe<Scalars['Int']>;
  messagesPerHour?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Array<DoorcontrolMetadataProp>>;
  name?: Maybe<Scalars['String']>;
  nfcAction?: Maybe<NfcAction>;
  offlineAccesslistEnabled?: Maybe<Scalars['Boolean']>;
  offlineReported?: Maybe<Scalars['Boolean']>;
  openDoorGPIOPin?: Maybe<Scalars['Int']>;
  openDoorPulseDuration?: Maybe<Scalars['Int']>;
  outOfOrder?: Maybe<Scalars['Boolean']>;
  powerlinkRebootEnabled?: Maybe<Scalars['Boolean']>;
  qrAction?: Maybe<QrAction>;
  rateLimit?: Maybe<Scalars['Int']>;
  remoteOpenEnabled?: Maybe<Scalars['Boolean']>;
  reportErrors?: Maybe<Scalars['Boolean']>;
  reportNodeOffline?: Maybe<Scalars['Boolean']>;
  reportOfflines?: Maybe<Scalars['Boolean']>;
  seita?: Maybe<SeitaState>;
  seitaEnabled?: Maybe<Scalars['Boolean']>;
  seitaGpioActive?: Maybe<Scalars['Boolean']>;
  seitaGpioPin?: Maybe<Scalars['Int']>;
  seitaurl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streamingCanbus?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export enum DoorcontrolConnectionUserType {
  Admin = 'Admin',
  Device = 'Device',
  Normal = 'Normal'
}

export type DoorcontrolDoor = {
  __typename?: 'DoorcontrolDoor';
  alarm?: Maybe<Scalars['Boolean']>;
  calibrating?: Maybe<Scalars['Boolean']>;
  door: Scalars['Int'];
  locked?: Maybe<Scalars['Boolean']>;
  node?: Maybe<Scalars['Int']>;
  segment?: Maybe<Scalars['Int']>;
};

export type DoorcontrolEvent = {
  __typename?: 'DoorcontrolEvent';
  doorcontrol?: Maybe<Doorcontrol>;
  doorcontrolId?: Maybe<Scalars['ID']>;
  eventType?: Maybe<DoorcontrolEventType>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export enum DoorcontrolEventType {
  CanbusConnected = 'CanbusConnected',
  CanbusDisconnected = 'CanbusDisconnected',
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  DoorAccessLocking = 'DoorAccessLocking',
  DoorAccessLockingResponse = 'DoorAccessLockingResponse',
  DoorAccessOpening = 'DoorAccessOpening',
  DoorAccessOpeningResponse = 'DoorAccessOpeningResponse',
  DoorAccessTimeout = 'DoorAccessTimeout',
  DoorCurrentSequenceNumber = 'DoorCurrentSequenceNumber',
  DoorSerial = 'DoorSerial',
  DoorVersion = 'DoorVersion',
  ErrorMessage = 'ErrorMessage',
  LockedDoorsRequest = 'LockedDoorsRequest',
  LockedDoorsResponse = 'LockedDoorsResponse',
  LockerAccessFeedback = 'LockerAccessFeedback',
  OpenLocker = 'OpenLocker',
  RequestLockerHistory = 'RequestLockerHistory',
  RequestLockerStatus = 'RequestLockerStatus',
  SendDoormapToLockerNodes = 'SendDoormapToLockerNodes'
}

export type DoorcontrolEventsConnection = {
  __typename?: 'DoorcontrolEventsConnection';
  doorcontrolEvents: Array<DoorcontrolEvent>;
  totalCount: Scalars['Int'];
};

export type DoorcontrolEventsQuery = {
  deviceNumber?: InputMaybe<Scalars['ID']>;
  doorcontrolEventType?: InputMaybe<DoorcontrolEventType>;
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type DoorcontrolLocker = {
  __typename?: 'DoorcontrolLocker';
  alarm?: Maybe<Scalars['Boolean']>;
  door?: Maybe<Scalars['Int']>;
  doorcontrolId: Scalars['Int'];
  id: Scalars['Int'];
  locked?: Maybe<Scalars['Boolean']>;
  node?: Maybe<Scalars['Int']>;
  online?: Maybe<Scalars['Boolean']>;
  serials?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['Int']>;
};

export type DoorcontrolLockersUpdate = {
  __typename?: 'DoorcontrolLockersUpdate';
  initialState?: Maybe<Array<DoorcontrolLocker>>;
  update?: Maybe<DoorcontrolLocker>;
};

export type DoorcontrolLogMessage = {
  __typename?: 'DoorcontrolLogMessage';
  deviceNumber: Scalars['String'];
  message: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type DoorcontrolMessage = {
  __typename?: 'DoorcontrolMessage';
  deviceNumber?: Maybe<Scalars['String']>;
  direction?: Maybe<MessageDirection>;
  message?: Maybe<Scalars['String']>;
  messagesPerHour?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type DoorcontrolMetadataProp = {
  __typename?: 'DoorcontrolMetadataProp';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DoorcontrolNode = {
  __typename?: 'DoorcontrolNode';
  node?: Maybe<Scalars['Int']>;
  panel?: Maybe<Scalars['Int']>;
  segment?: Maybe<Scalars['Int']>;
  serials?: Maybe<Array<Maybe<Scalars['Int']>>>;
  state?: Maybe<HeartbeatState>;
  version?: Maybe<Scalars['Int']>;
};

export type DoorcontrolStateChange = {
  __typename?: 'DoorcontrolStateChange';
  deviceNumber?: Maybe<Scalars['String']>;
  doorcontrolLockers?: Maybe<Array<DoorcontrolLocker>>;
  seita?: Maybe<SeitaState>;
  updateEtaSeconds?: Maybe<Scalars['Int']>;
  updatePercent?: Maybe<Scalars['Int']>;
  updateStopped?: Maybe<Scalars['Boolean']>;
};

export type DoorcontrolsConnection = {
  __typename?: 'DoorcontrolsConnection';
  doorcontrols: Array<Doorcontrol>;
};

export type DoormapRow = {
  access?: InputMaybe<Scalars['Boolean']>;
  cluster: Scalars['String'];
  darkmode?: InputMaybe<Scalars['Boolean']>;
  demo?: InputMaybe<Scalars['Boolean']>;
  desfire?: InputMaybe<Scalars['Boolean']>;
  fastAlarm?: InputMaybe<Scalars['Boolean']>;
  hid?: InputMaybe<Scalars['Boolean']>;
  hslDesfire?: InputMaybe<Scalars['Boolean']>;
  keepLock?: InputMaybe<Scalars['Boolean']>;
  keyCheck?: InputMaybe<Scalars['Boolean']>;
  leftDownDoorNr?: InputMaybe<Scalars['Int']>;
  leftOpen?: InputMaybe<Scalars['Boolean']>;
  leftUpDoorNr?: InputMaybe<Scalars['Int']>;
  mifare?: InputMaybe<Scalars['Boolean']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  multiuse?: InputMaybe<Scalars['Boolean']>;
  node: Scalars['Int'];
  openMask?: InputMaybe<Scalars['Int']>;
  personal?: InputMaybe<Scalars['Boolean']>;
  rightDownDoorNr?: InputMaybe<Scalars['Int']>;
  rightOpen?: InputMaybe<Scalars['Boolean']>;
  rightUpDoorNr?: InputMaybe<Scalars['Int']>;
  segment: Scalars['Int'];
  silent?: InputMaybe<Scalars['Boolean']>;
  sote?: InputMaybe<Scalars['Boolean']>;
  ultralight?: InputMaybe<Scalars['Boolean']>;
  verticalDoubleLock?: InputMaybe<Scalars['Boolean']>;
};

export type DoormapTarget = {
  node: Scalars['Int'];
  segment: Scalars['Int'];
};

export type DownloadNewDoormapResponse = {
  __typename?: 'DownloadNewDoormapResponse';
  status?: Maybe<CommandStatus>;
};

export type EditAccessCard = {
  cardName?: InputMaybe<Scalars['String']>;
  cardnumber?: InputMaybe<Scalars['String']>;
  validityEnd?: InputMaybe<Scalars['DateTime']>;
  validityStart?: InputMaybe<Scalars['DateTime']>;
};

export type EditAccessListUser = {
  accessCards?: InputMaybe<Array<InputMaybe<EditAccessCard>>>;
  accesslistId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type EditAccessListUserResponse = {
  __typename?: 'EditAccessListUserResponse';
  user?: Maybe<User>;
};

export type EventLog = {
  __typename?: 'EventLog';
  companyId?: Maybe<Scalars['ID']>;
  delivery?: Maybe<Delivery>;
  doorcontrol?: Maybe<Doorcontrol>;
  eventTime: Scalars['DateTime'];
  eventType: Scalars['Int'];
  id: Scalars['ID'];
  item?: Maybe<Item>;
  locker?: Maybe<Locker>;
  lockersystem?: Maybe<Lockersystem>;
  message: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  renting?: Maybe<Renting>;
  reservationId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
};

export type EventLogsConnection = {
  __typename?: 'EventLogsConnection';
  eventLogs: Array<EventLog>;
  totalCount: Scalars['Int'];
};

export type EventLogsQueryInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  deliveryId?: InputMaybe<Scalars['ID']>;
  doorcontrolId?: InputMaybe<Scalars['ID']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventTypes?: InputMaybe<Array<Scalars['Int']>>;
  itemId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  rentingId?: InputMaybe<Scalars['ID']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type FactoryResetLocker = {
  deviceNumber: Scalars['String'];
  door?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<Scalars['Int']>;
};

export type FactoryResetLockerResponse = {
  __typename?: 'FactoryResetLockerResponse';
  status?: Maybe<CommandStatus>;
};

export enum Feature {
  Accesslists = 'Accesslists',
  DahsboardLatestStucks = 'DahsboardLatestStucks',
  Dashboard = 'Dashboard',
  DashboardGateStatistics = 'DashboardGateStatistics',
  DashboardGroupsUsage = 'DashboardGroupsUsage',
  DashboardLatestAlarms = 'DashboardLatestAlarms',
  Doormaps = 'Doormaps',
  GateUseHistory = 'GateUseHistory',
  Lainaamo = 'Lainaamo',
  RaportGateGroupStatistics = 'RaportGateGroupStatistics',
  RaportGateStatistics = 'RaportGateStatistics',
  RaportLockerSearch = 'RaportLockerSearch',
  RaportLockerStatistics = 'RaportLockerStatistics',
  Raports = 'Raports',
  UseHistory = 'UseHistory'
}

export type Feedback = {
  __typename?: 'Feedback';
  delivery?: Maybe<Delivery>;
  eventTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  locker?: Maybe<Locker>;
  lockerGroup?: Maybe<LockerGroup>;
  lockersystem?: Maybe<Lockersystem>;
  message?: Maybe<Scalars['String']>;
  renting?: Maybe<Renting>;
  type?: Maybe<FeedbackType>;
  user?: Maybe<User>;
};

export enum FeedbackType {
  DeliveryDeliverDoorAcidentClosed = 'DeliveryDeliverDoorAcidentClosed',
  DeliveryDeliverDoorDidNotOpen = 'DeliveryDeliverDoorDidNotOpen',
  DeliveryDeliverOtherError = 'DeliveryDeliverOtherError',
  DeliveryPickupDoorAcidentClosed = 'DeliveryPickupDoorAcidentClosed',
  DeliveryPickupDoorDidNotOpen = 'DeliveryPickupDoorDidNotOpen',
  DeliveryPickupFaltyItem = 'DeliveryPickupFaltyItem',
  DeliveryPickupItemMissingFromLocker = 'DeliveryPickupItemMissingFromLocker',
  DeliveryPickupOtherError = 'DeliveryPickupOtherError',
  DeliveryPickupWrongItem = 'DeliveryPickupWrongItem',
  GeneralOtherError = 'GeneralOtherError',
  RentingDuringFaltyItem = 'RentingDuringFaltyItem',
  RentingDuringItemBroke = 'RentingDuringItemBroke',
  RentingDuringItemLost = 'RentingDuringItemLost',
  RentingDuringItemNeedService = 'RentingDuringItemNeedService',
  RentingDuringOtherError = 'RentingDuringOtherError',
  RentingDuringWrongItem = 'RentingDuringWrongItem',
  RentingReturnDoorAcidentClosed = 'RentingReturnDoorAcidentClosed',
  RentingReturnDoorDidNotOpen = 'RentingReturnDoorDidNotOpen',
  RentingReturnOtherError = 'RentingReturnOtherError',
  RentingStartDoorAcidentClosed = 'RentingStartDoorAcidentClosed',
  RentingStartDoorDidNotOpen = 'RentingStartDoorDidNotOpen',
  RentingStartFaltyItem = 'RentingStartFaltyItem',
  RentingStartItemMissingFromLocker = 'RentingStartItemMissingFromLocker',
  RentingStartOtherError = 'RentingStartOtherError',
  RentingStartWrongItem = 'RentingStartWrongItem'
}

export type FeedbacksQuery = {
  end?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<FeedbackType>;
};

export type FetchNodeInfo = {
  deviceNumber: Scalars['String'];
  node: Scalars['Int'];
  segment: Scalars['Int'];
};

export type FetchNodeInfoResponse = {
  __typename?: 'FetchNodeInfoResponse';
  status?: Maybe<CommandStatus>;
};

export type FinishPasskeyLoginInput = {
  challengeId: Scalars['ID'];
  response: Scalars['JSON'];
};

export type FinishPasskeyLoginResponse = {
  __typename?: 'FinishPasskeyLoginResponse';
  token: Scalars['String'];
  userName: Scalars['String'];
};

export type FinishPasskeyRegistrationInput = {
  challengeId: Scalars['ID'];
  response: Scalars['JSON'];
};

export type FinishPasskeyRegistrationResponse = {
  __typename?: 'FinishPasskeyRegistrationResponse';
  passkey: Passkey;
};

export type ForgetDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type ForgetDoorcontrolResponse = {
  __typename?: 'ForgetDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
  status: CommandStatus;
};

export type Freepass = {
  areaId: Scalars['ID'];
  companyId: Scalars['ID'];
  gateId: Scalars['ID'];
  handicap?: InputMaybe<Scalars['Boolean']>;
  nodeId: Scalars['ID'];
};

export type FreepassResponse = {
  __typename?: 'FreepassResponse';
  node?: Maybe<GateNode>;
};

export enum Gate_Sort_Option {
  NodeAsc = 'NODE_ASC',
  NodeDesc = 'NODE_DESC',
  OpenedAsc = 'OPENED_ASC',
  OpenedDesc = 'OPENED_DESC'
}

export type Gate = {
  __typename?: 'Gate';
  dailyCount?: Maybe<Scalars['Int']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  node?: Maybe<Scalars['String']>;
  outCount?: Maybe<Scalars['Int']>;
  passivated?: Maybe<Scalars['Boolean']>;
};

export type GateEvent = {
  __typename?: 'GateEvent';
  cardNumber?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<GateEventType>;
  gate?: Maybe<Gate>;
  id: Scalars['ID'];
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export enum GateEventType {
  GateIn = 'GATE_IN',
  GateOut = 'GATE_OUT'
}

export type GateGroup = {
  __typename?: 'GateGroup';
  id?: Maybe<Scalars['ID']>;
  inCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  outCount?: Maybe<Scalars['Int']>;
};

export type GateGroupGatesConnection = {
  __typename?: 'GateGroupGatesConnection';
  gates: Array<Gate>;
  totalCount: Scalars['Int'];
};

export type GateHistoryConnection = {
  __typename?: 'GateHistoryConnection';
  gateEvents: Array<GateEvent>;
  totalCount: Scalars['Int'];
};

export type GateNode = {
  __typename?: 'GateNode';
  allowCloseSales: Scalars['Boolean'];
  allowOpenSales: Scalars['Boolean'];
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  connectionEndedAt?: Maybe<Scalars['DateTime']>;
  connectionStartedAt?: Maybe<Scalars['DateTime']>;
  counter?: Maybe<Scalars['Int']>;
  deviceNumber?: Maybe<Scalars['String']>;
  gateId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  lastChangedAt?: Maybe<Scalars['DateTime']>;
  lastRealCounterChange?: Maybe<Scalars['DateTime']>;
  nodeId?: Maybe<Scalars['ID']>;
  online?: Maybe<Scalars['Boolean']>;
  open?: Maybe<Scalars['Boolean']>;
  useForCounters: Scalars['Boolean'];
  version?: Maybe<Scalars['String']>;
};

export type GateNodeEvent = {
  __typename?: 'GateNodeEvent';
  areaId?: Maybe<Scalars['String']>;
  cardnumber?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  deviceNumber?: Maybe<Scalars['String']>;
  gateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  nodeId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<GateNodeEventType>;
  validationDirection?: Maybe<ValidationDirection>;
  validationErrorCode?: Maybe<Scalars['String']>;
  validationType?: Maybe<ValidationType>;
  version?: Maybe<Scalars['String']>;
};

export enum GateNodeEventType {
  CloseSales = 'CloseSales',
  CloseSalesTransmitted = 'CloseSalesTransmitted',
  Freepass = 'Freepass',
  FreepassTransmitted = 'FreepassTransmitted',
  Handicap = 'Handicap',
  HandicapTransmitted = 'HandicapTransmitted',
  NodeOffline = 'NodeOffline',
  NodeOnline = 'NodeOnline',
  NodeSalesClosed = 'NodeSalesClosed',
  NodeSalesOpened = 'NodeSalesOpened',
  OpenSales = 'OpenSales',
  OpenSalesTransmitted = 'OpenSalesTransmitted',
  Validation = 'Validation'
}

export type GateNodeEventsConnection = {
  __typename?: 'GateNodeEventsConnection';
  gateNodeEvents: Array<GateNodeEvent>;
};

export type GateNodesConnection = {
  __typename?: 'GateNodesConnection';
  gateNodes?: Maybe<Array<Maybe<GateNode>>>;
};

export type GateState = {
  __typename?: 'GateState';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  gateId?: Maybe<Scalars['ID']>;
  inCounter?: Maybe<Scalars['Int']>;
  outCounter?: Maybe<Scalars['Int']>;
};

export type GivePermit = {
  rentingId: Scalars['ID'];
};

export type GivePermitResponse = {
  __typename?: 'GivePermitResponse';
  renting: Renting;
};

export type GoogleWalletConfiguration = {
  __typename?: 'GoogleWalletConfiguration';
  classId?: Maybe<Scalars['String']>;
  credentialsPath?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  issuerId?: Maybe<Scalars['String']>;
  ready: Scalars['Boolean'];
  serviceAccountEmail?: Maybe<Scalars['String']>;
};

export enum GuiMode {
  Admin = 'Admin',
  HwInstall = 'HwInstall',
  HwTest = 'HwTest',
  Lainaamo = 'Lainaamo',
  LockedDoors = 'LockedDoors',
  None = 'None',
  OpenDoor = 'OpenDoor',
  Storage = 'Storage',
  Storage2 = 'Storage2'
}

export type HakaUserCallback = {
  commonName?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  eduPersonPrincipalName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  issuer?: InputMaybe<Scalars['String']>;
  mailAtribute?: InputMaybe<Scalars['String']>;
  nameID?: InputMaybe<Scalars['String']>;
  nameIDFormat?: InputMaybe<Scalars['String']>;
  schacHomeOrganization?: InputMaybe<Scalars['String']>;
  schacHomeOrganizationType?: InputMaybe<Scalars['String']>;
  sessionIndex?: InputMaybe<Scalars['String']>;
};

export type HakaUserCallbackResponse = {
  __typename?: 'HakaUserCallbackResponse';
  code: Scalars['String'];
};

export enum HeartbeatState {
  BootingUp = 'BootingUp',
  NoClock = 'NoClock',
  NoSegment = 'NoSegment',
  Operational = 'Operational',
  PreOperational = 'PreOperational',
  Stopped = 'Stopped'
}

export enum IncomeStatisticsGroupBy {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type IncomeStatisticsRow = {
  __typename?: 'IncomeStatisticsRow';
  bucketStart: Scalars['DateTime'];
  incomeCents: Scalars['Int'];
};

export type InterruptDelivery = {
  deliveryId: Scalars['ID'];
};

export type InterruptDeliveryResponse = {
  __typename?: 'InterruptDeliveryResponse';
  delivery: Delivery;
};

export type InterruptRenting = {
  rentingId: Scalars['ID'];
};

export type InterruptRentingResponse = {
  __typename?: 'InterruptRentingResponse';
  renting: Renting;
};

export type InvitePortalUserToLockersystem = {
  admin: Scalars['Boolean'];
  lockersystemId: Scalars['ID'];
  portalUserId: Scalars['String'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};

export type InvitePortalUserToLockersystemResponse = {
  __typename?: 'InvitePortalUserToLockersystemResponse';
  lockersystem?: Maybe<Lockersystem>;
  user?: Maybe<User>;
};

export type Item = {
  __typename?: 'Item';
  activeRenting?: Maybe<Renting>;
  available?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationCode?: Maybe<Scalars['String']>;
  creationCodeUsedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailAdminWhenReturned?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageFileId?: Maybe<Scalars['ID']>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId?: Maybe<Scalars['ID']>;
  locker?: Maybe<Locker>;
  lockerGroup?: Maybe<LockerGroup>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  needsPermit?: Maybe<Scalars['Boolean']>;
  removeCode?: Maybe<Scalars['String']>;
  removeCodeUsedAt?: Maybe<Scalars['DateTime']>;
  rentable?: Maybe<Scalars['Boolean']>;
  rentingTime?: Maybe<Scalars['Int']>;
  rentings: Array<Renting>;
  useCreationCodeBefore?: Maybe<Scalars['DateTime']>;
  useRemoveCodeBefore?: Maybe<Scalars['DateTime']>;
  whoCreated?: Maybe<User>;
  whoDeleted?: Maybe<User>;
  whoRemoved?: Maybe<User>;
};


export type ItemRentingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ItemGroup = {
  __typename?: 'ItemGroup';
  borrowingRightsUserGroups: Array<UserGroup>;
  id: Scalars['ID'];
  items: Array<Item>;
  lockersystem: Lockersystem;
  lockersystemId: Scalars['ID'];
  maxRentingsPerUser?: Maybe<Scalars['Int']>;
  maxRentingsPerUserEnabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ItemGroupsConnection = {
  __typename?: 'ItemGroupsConnection';
  itemGroups: Array<ItemGroup>;
};

export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  items: Array<Item>;
};

export type Job = {
  __typename?: 'Job';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  data: Scalars['JSON'];
  id: Scalars['ID'];
  jobType: JobType;
  recipientUsers: Array<User>;
  requestedBy?: Maybe<User>;
  requestedByUserId: Scalars['ID'];
  status: JobStatus;
  updatedAt: Scalars['DateTime'];
};

export type JobLogEntry = {
  __typename?: 'JobLogEntry';
  attempt?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  dataset?: Maybe<Scalars['String']>;
  etaSeconds?: Maybe<Scalars['Int']>;
  jobId: Scalars['ID'];
  level: Scalars['String'];
  maxAttempts?: Maybe<Scalars['Int']>;
  message: Scalars['String'];
  percent?: Maybe<Scalars['Float']>;
  rowsRemaining?: Maybe<Scalars['Int']>;
  rowsWritten?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export enum JobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum JobType {
  DataExport = 'DATA_EXPORT',
  MaintenanceReport = 'MAINTENANCE_REPORT'
}

export type JoinUserToLockersystem = {
  lockersystemUrlId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type JoinUserToLockersystemResponse = {
  __typename?: 'JoinUserToLockersystemResponse';
  alreadyJoined: Scalars['Boolean'];
  lockersystem?: Maybe<Lockersystem>;
  user?: Maybe<User>;
};

export enum Locker_Node_Type {
  Doors_1 = 'DOORS_1',
  Doors_2 = 'DOORS_2',
  Doors_4 = 'DOORS_4'
}

export enum Locker_Order_By {
  CardId = 'CARD_ID',
  DoorName = 'DOOR_NAME',
  EventDatetime = 'EVENT_DATETIME',
  Status = 'STATUS'
}

export enum Locker_Statistics_Row_Order_By_Column {
  Alarm = 'ALARM',
  Breakin = 'BREAKIN',
  Locked = 'LOCKED',
  Name = 'NAME',
  Opened = 'OPENED',
  Stuck = 'STUCK'
}

export type LainaamoUsageRow = {
  __typename?: 'LainaamoUsageRow';
  bucketStart: Scalars['DateTime'];
  deliveriesCount: Scalars['Int'];
  rentingsCount: Scalars['Int'];
};

export enum LocalApiEnabled {
  Local = 'Local',
  Off = 'Off',
  On = 'On'
}

export type Locker = {
  __typename?: 'Locker';
  accessGroup?: Maybe<AccessGroup>;
  accessGroupId?: Maybe<Scalars['ID']>;
  alarm?: Maybe<Scalars['Boolean']>;
  cardId?: Maybe<Scalars['String']>;
  cluster?: Maybe<Cluster>;
  delivery?: Maybe<Delivery>;
  depth?: Maybe<Scalars['Int']>;
  doorcontrol?: Maybe<Doorcontrol>;
  environmentId?: Maybe<Scalars['ID']>;
  events?: Maybe<Array<LockerEvent>>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  item?: Maybe<Item>;
  keepLockOn?: Maybe<Scalars['Boolean']>;
  lastLockedAt?: Maybe<Scalars['DateTime']>;
  lastOnlineAt?: Maybe<Scalars['DateTime']>;
  locked?: Maybe<Scalars['Boolean']>;
  lockerBoard?: Maybe<LockerBoard>;
  lockerBoardId?: Maybe<Scalars['ID']>;
  lockerGroup?: Maybe<LockerGroup>;
  lockerGroupId?: Maybe<Scalars['ID']>;
  lockerNode?: Maybe<LockerNode>;
  lockerNodeId?: Maybe<Scalars['ID']>;
  lockerSeq?: Maybe<Scalars['Int']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  maintenanceMode?: Maybe<Scalars['Boolean']>;
  mode?: Maybe<LockerMode>;
  name: Scalars['Int'];
  newestEventDate?: Maybe<Scalars['String']>;
  online?: Maybe<Scalars['Boolean']>;
  passivated?: Maybe<Scalars['Boolean']>;
  reservation?: Maybe<Reservation>;
  serialNumber?: Maybe<Scalars['String']>;
  status?: Maybe<LockerStatus>;
  stuck?: Maybe<Scalars['Boolean']>;
  terminal?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type LockerAccessFeedback = {
  __typename?: 'LockerAccessFeedback';
  accessType?: Maybe<AccessType>;
  cardnumber?: Maybe<Scalars['String']>;
  doorcontrol?: Maybe<Doorcontrol>;
  id: Scalars['ID'];
  locker?: Maybe<Locker>;
  lockersystem?: Maybe<Lockersystem>;
  master?: Maybe<Scalars['Boolean']>;
  offlineDecision?: Maybe<Scalars['Boolean']>;
  onlineDecision?: Maybe<Scalars['Boolean']>;
  onlineRelease?: Maybe<Scalars['Boolean']>;
  responseTime?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type LockerBoard = {
  __typename?: 'LockerBoard';
  boardNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<Array<LockerEvent>>;
  fluorescent?: Maybe<Scalars['Boolean']>;
  halBoardNumber?: Maybe<Scalars['String']>;
  halFluorescent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locker?: Maybe<Locker>;
  masterWhitelistMatches?: Maybe<Scalars['Boolean']>;
  masterWhitelistVersion?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['Int']>;
  status: LockerBoardStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum LockerBoardStatus {
  InMaintenance = 'IN_MAINTENANCE',
  NeedsMaintenance = 'NEEDS_MAINTENANCE',
  Unassigned = 'UNASSIGNED'
}

export type LockerBoardsConnection = {
  __typename?: 'LockerBoardsConnection';
  boards: Array<LockerBoard>;
  totalCount: Scalars['Int'];
};

export type LockerBoardsQuery = {
  boardNumber?: InputMaybe<Scalars['String']>;
  doorcontrolDeviceNumber?: InputMaybe<Scalars['String']>;
  halBoardNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  panelIdentifier?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LockerBoardStatus>;
};

export type LockerDailyStatisticsRow = {
  __typename?: 'LockerDailyStatisticsRow';
  alarmCount?: Maybe<Scalars['Int']>;
  breakInAlarmCount?: Maybe<Scalars['Int']>;
  day: Scalars['DateTime'];
  lockedCount?: Maybe<Scalars['Int']>;
  openedCount?: Maybe<Scalars['Int']>;
  stuckCount?: Maybe<Scalars['Int']>;
};

export type LockerEvent = {
  __typename?: 'LockerEvent';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  locker?: Maybe<Locker>;
  lockerBoard?: Maybe<LockerBoard>;
  note?: Maybe<Scalars['String']>;
  type: LockerEventType;
};

export enum LockerEventType {
  LockerAlarmBurst = 'LOCKER_ALARM_BURST',
  LockerBoardChanged = 'LOCKER_BOARD_CHANGED',
  MaintenanceNote = 'MAINTENANCE_NOTE'
}

export type LockerGroup = {
  __typename?: 'LockerGroup';
  childLockerGroups: Array<LockerGroup>;
  doorcontrols: Array<Doorcontrol>;
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  lainaamo: Scalars['Boolean'];
  lockedCount: Scalars['Int'];
  lockerCount: Scalars['Int'];
  lockerUnits: Array<LockerUnit>;
  lockers: Array<Locker>;
  lockersystemId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  openCount: Scalars['Int'];
  parentLockerGroup?: Maybe<LockerGroup>;
  parentLockerGroupId?: Maybe<Scalars['ID']>;
};


export type LockerGroupChildLockerGroupsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type LockerGroupLockersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type LockerGroupAccess = {
  __typename?: 'LockerGroupAccess';
  accesslistId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  lockerGroup?: Maybe<LockerGroup>;
  lockerGroupId: Scalars['ID'];
  master?: Maybe<Scalars['Boolean']>;
  maxLockedCount?: Maybe<Scalars['Int']>;
};

export type LockerGroupItemsConnection = {
  __typename?: 'LockerGroupItemsConnection';
  items: Array<Item>;
  totalCount: Scalars['Int'];
};

export type LockerGroupsConnection = {
  __typename?: 'LockerGroupsConnection';
  lockerGroups?: Maybe<Array<Maybe<LockerGroup>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LockerHistoryEvent = {
  __typename?: 'LockerHistoryEvent';
  cardId?: Maybe<Scalars['ID']>;
  eventType?: Maybe<LockerHistoryEventType>;
  id: Scalars['ID'];
  locker?: Maybe<Locker>;
  lockerId?: Maybe<Scalars['ID']>;
  lockerSeq?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userName?: Maybe<Scalars['String']>;
};

export enum LockerHistoryEventType {
  AdminOpen = 'ADMIN_OPEN',
  Alarm = 'ALARM',
  BreakInAlarm = 'BREAK_IN_ALARM',
  Closed = 'CLOSED',
  DoorhubRemoteOpenDoor = 'DOORHUB_REMOTE_OPEN_DOOR',
  LainaamoOpenDoor = 'LAINAAMO_OPEN_DOOR',
  MasterClose = 'MASTER_CLOSE',
  MasterOpen = 'MASTER_OPEN',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Open = 'OPEN',
  OpenReceived = 'OPEN_RECEIVED',
  RemoteOpen = 'REMOTE_OPEN',
  Stuck = 'STUCK',
  StuckOpen = 'STUCK_OPEN'
}

export type LockerHistoryEventsConnection = {
  __typename?: 'LockerHistoryEventsConnection';
  lockerHistoryEvents: Array<LockerHistoryEvent>;
};

export enum LockerMode {
  Renting = 'RENTING',
  Use = 'USE'
}

export type LockerNode = {
  __typename?: 'LockerNode';
  access?: Maybe<Scalars['Boolean']>;
  clusterId?: Maybe<Scalars['ID']>;
  clusterName?: Maybe<Scalars['String']>;
  darkmode?: Maybe<Scalars['Boolean']>;
  demo?: Maybe<Scalars['Boolean']>;
  desfire?: Maybe<Scalars['Boolean']>;
  doorNumberLeftDown?: Maybe<Scalars['Int']>;
  doorNumberLeftUp?: Maybe<Scalars['Int']>;
  doorNumberRightDown?: Maybe<Scalars['Int']>;
  doorNumberRightUp?: Maybe<Scalars['Int']>;
  doorNumbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  fastAlarm?: Maybe<Scalars['Boolean']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  hid?: Maybe<Scalars['Boolean']>;
  hslDesfire?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  keepLock?: Maybe<Scalars['Boolean']>;
  keyCheck?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['Int']>;
  leftDownDoorVisible?: Maybe<Scalars['Boolean']>;
  leftDownLocker?: Maybe<Locker>;
  leftOpen?: Maybe<Scalars['Boolean']>;
  leftUpDoorVisible?: Maybe<Scalars['Boolean']>;
  leftUpLocker?: Maybe<Locker>;
  lockerNodeType?: Maybe<Locker_Node_Type>;
  lockerUnitId?: Maybe<Scalars['ID']>;
  lockers?: Maybe<Array<Maybe<Locker>>>;
  mifare?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['Boolean']>;
  multiuse?: Maybe<Scalars['Boolean']>;
  nodeNumber?: Maybe<Scalars['Int']>;
  openMask?: Maybe<Scalars['Int']>;
  personal?: Maybe<Scalars['Boolean']>;
  rightDownDoorVisible?: Maybe<Scalars['Boolean']>;
  rightDownLocker?: Maybe<Locker>;
  rightOpen?: Maybe<Scalars['Boolean']>;
  rightUpDoorVisible?: Maybe<Scalars['Boolean']>;
  rightUpLocker?: Maybe<Locker>;
  segment: Scalars['Int'];
  silent?: Maybe<Scalars['Boolean']>;
  sote?: Maybe<Scalars['Boolean']>;
  ultralight?: Maybe<Scalars['Boolean']>;
  verticalDoubleLock?: Maybe<Scalars['Boolean']>;
};

export type LockerNodeUpdateProgress = {
  __typename?: 'LockerNodeUpdateProgress';
  percent?: Maybe<Scalars['Int']>;
};

export type LockerNodesConnection = {
  __typename?: 'LockerNodesConnection';
  lockerNodes?: Maybe<Array<Maybe<LockerNode>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LockerProgram = {
  __typename?: 'LockerProgram';
  applicationId?: Maybe<Scalars['Int']>;
  buildDate?: Maybe<Scalars['Int']>;
  cpuCardType?: Maybe<Scalars['Int']>;
  cpuCardType2?: Maybe<Scalars['Int']>;
  cpuCardType3?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  labels: Array<LockerProgramLabel>;
  length?: Maybe<Scalars['String']>;
  originalFileName?: Maybe<Scalars['String']>;
  programType?: Maybe<Scalars['Int']>;
  tested?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type LockerProgramLabel = {
  __typename?: 'LockerProgramLabel';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lockerProgram?: Maybe<LockerProgram>;
  name: Scalars['String'];
};

export type LockerState = {
  cardnumber?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  lockerNumber: Scalars['Int'];
};

export type LockerStatisticsOpt = {
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Locker_Statistics_Row_Order_By_Column>;
  orderByDirection?: InputMaybe<Order_By_Direction>;
  untillDate?: InputMaybe<Scalars['DateTime']>;
};

export type LockerStatisticsRow = {
  __typename?: 'LockerStatisticsRow';
  alarmCount?: Maybe<Scalars['Int']>;
  breakInAlarmCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  lockedCount?: Maybe<Scalars['Int']>;
  locker?: Maybe<Locker>;
  lockerName?: Maybe<Scalars['Int']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  openedCount?: Maybe<Scalars['Int']>;
  stuckCount?: Maybe<Scalars['Int']>;
};

export type LockerStatisticsRowsConnection = {
  __typename?: 'LockerStatisticsRowsConnection';
  lockerStatisticsRows?: Maybe<Array<Maybe<LockerStatisticsRow>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum LockerStatus {
  Alarm = 'ALARM',
  Locked = 'LOCKED',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Open = 'OPEN',
  Stuck = 'STUCK'
}

export type LockerUnit = {
  __typename?: 'LockerUnit';
  id?: Maybe<Scalars['ID']>;
  lockerNodes: Array<LockerNode>;
};

export type LockerVersionLockersystemStat = {
  __typename?: 'LockerVersionLockersystemStat';
  id?: Maybe<Scalars['ID']>;
  lockerCount: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type LockerVersionStat = {
  __typename?: 'LockerVersionStat';
  lockerCount: Scalars['Int'];
  lockersystems: Array<LockerVersionLockersystemStat>;
  percentage: Scalars['Float'];
  version: Scalars['Int'];
};

export type LockerVersionSummary = {
  __typename?: 'LockerVersionSummary';
  totalLockers: Scalars['Int'];
  versions: Array<LockerVersionStat>;
};

export type LockerhistoryEventsQuery = {
  cardnumber?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  eventTypes?: InputMaybe<Array<InputMaybe<LockerHistoryEventType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type LockersConnection = {
  __typename?: 'LockersConnection';
  lockers?: Maybe<Array<Maybe<Locker>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LockersOpt = {
  companyId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  maintenanceMode?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  stateChangedBefore?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<LockerStatus>;
};

export type Lockersystem = {
  __typename?: 'Lockersystem';
  accessGroups: Array<AccessGroup>;
  accesslists?: Maybe<Array<Maybe<Accesslist>>>;
  activeDeliveries: LockersystemActiveDeliveriesConnection;
  activeRentings: LockersystemActiveRentingsConnection;
  adminEmailUserGroupId?: Maybe<Scalars['ID']>;
  alarmsTodayCount: Scalars['Int'];
  alertsEnabled?: Maybe<Scalars['Boolean']>;
  anonymousQrReservationAllowed: Scalars['Boolean'];
  anyReservations: Scalars['Boolean'];
  anyTransactions: Scalars['Boolean'];
  automaticAdminPasswordChange?: Maybe<Scalars['Boolean']>;
  breakinAlertsEnabled?: Maybe<Scalars['Boolean']>;
  cabinetType?: Maybe<LockersystemCabinetType>;
  cardKeysId?: Maybe<Scalars['ID']>;
  clusters: Array<Cluster>;
  companyIds: Array<Scalars['ID']>;
  dashboardLayoutId: DashboardLayoutType;
  deliveryAllowed?: Maybe<Scalars['Boolean']>;
  deliveryNonRegistered?: Maybe<Scalars['Boolean']>;
  deliveryWithIdentityCode?: Maybe<Scalars['Boolean']>;
  doormapCsv?: Maybe<Scalars['String']>;
  emailPermissionDomains: Array<Scalars['String']>;
  googleUsersAllowed?: Maybe<Scalars['Boolean']>;
  hasAccesslist?: Maybe<Scalars['Boolean']>;
  hasNonKeepLockLockers: Scalars['Boolean'];
  id: Scalars['ID'];
  installationDate?: Maybe<Scalars['DateTime']>;
  itemGroups: Array<ItemGroup>;
  items: LockersystemItemsConnection;
  lainaamoTranslations: Array<TranslationItem>;
  lockedLockersCount: Scalars['Int'];
  lockerGroups: Array<LockerGroup>;
  lockerNodes: Array<LockerNode>;
  lockerUnits: Array<LockerUnit>;
  lockerhistory: Array<LockerHistoryEvent>;
  lockers: Array<Locker>;
  lockersWithoutAccessGroup: Array<Locker>;
  lockersWithoutLockerGroup: Array<Locker>;
  maintenanceMode?: Maybe<Scalars['Boolean']>;
  masterCards: Array<MasterCard>;
  masterWhitelist?: Maybe<MasterWhitelist>;
  masterWhitelistBoardStatus: MasterWhitelistBoardStatus;
  name?: Maybe<Scalars['String']>;
  newLockerProgramLabelId?: Maybe<Scalars['ID']>;
  oldLockerProgramLabelId?: Maybe<Scalars['ID']>;
  openLockersCount: Scalars['Int'];
  openSystem?: Maybe<Scalars['Boolean']>;
  ouluUniUsersAllowed?: Maybe<Scalars['Boolean']>;
  passivated?: Maybe<Scalars['Boolean']>;
  publicDashboardEnabled?: Maybe<Scalars['Boolean']>;
  rentingAllowed?: Maybe<Scalars['Boolean']>;
  rentingLateNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  rentingNonRegistered?: Maybe<Scalars['Boolean']>;
  replyToEmail?: Maybe<Scalars['String']>;
  showWhoBorrows?: Maybe<Scalars['Boolean']>;
  sympathyAlarmCount?: Maybe<Scalars['Int']>;
  totalLockersCount: Scalars['Int'];
  translations: Array<Translation>;
  urlId?: Maybe<Scalars['String']>;
  userPermissions: Array<LockersystemUserPermission>;
};


export type LockersystemHasAccesslistArgs = {
  accesslistId: Scalars['ID'];
};


export type LockersystemItemGroupsArgs = {
  searchWord?: InputMaybe<Scalars['String']>;
};


export type LockersystemItemsArgs = {
  options: LockersystemItemsSearchOptions;
};


export type LockersystemLockerGroupsArgs = {
  lainaamo?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type LockersystemLockerhistoryArgs = {
  opt: LockersystemLockerhistoryOpt;
};

export type LockersystemActiveDeliveriesConnection = {
  __typename?: 'LockersystemActiveDeliveriesConnection';
  deliveries: Array<Delivery>;
};

export type LockersystemActiveRentingsConnection = {
  __typename?: 'LockersystemActiveRentingsConnection';
  rentings: Array<Renting>;
};

export enum LockersystemCabinetType {
  Aluminium = 'ALUMINIUM',
  Wood = 'WOOD'
}

export type LockersystemClustersConnection = {
  __typename?: 'LockersystemClustersConnection';
  clusters?: Maybe<Array<Maybe<Cluster>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LockersystemGatesConnection = {
  __typename?: 'LockersystemGatesConnection';
  gates?: Maybe<Array<Maybe<Gate>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LockersystemItemsConnection = {
  __typename?: 'LockersystemItemsConnection';
  items: Array<Item>;
};

export type LockersystemItemsSearchOptions = {
  rentable?: InputMaybe<Scalars['Boolean']>;
  searchWord?: InputMaybe<Scalars['String']>;
};

export type LockersystemLockerEventsQuery = {
  eventTypes?: InputMaybe<Array<LockerEventType>>;
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type LockersystemLockerhistoryOpt = {
  cardnumber?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  eventTypes?: InputMaybe<Array<InputMaybe<LockerHistoryEventType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type LockersystemRecentEvent = {
  __typename?: 'LockersystemRecentEvent';
  deliveryDescription?: Maybe<Scalars['String']>;
  deliveryId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['ID']>;
  itemName?: Maybe<Scalars['String']>;
  lockerId?: Maybe<Scalars['ID']>;
  lockerName?: Maybe<Scalars['Int']>;
  rentingId?: Maybe<Scalars['ID']>;
  timestamp: Scalars['DateTime'];
  type: LockersystemRecentEventType;
};

export enum LockersystemRecentEventType {
  DeliveryDropped = 'DELIVERY_DROPPED',
  DeliveryPickedUp = 'DELIVERY_PICKED_UP',
  LockerBreakInAlarm = 'LOCKER_BREAK_IN_ALARM',
  RentingReturned = 'RENTING_RETURNED',
  RentingStarted = 'RENTING_STARTED'
}

export enum LockersystemRole {
  Maintainer = 'MAINTAINER'
}

export type LockersystemSubscription = {
  __typename?: 'LockersystemSubscription';
  companyId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deviceNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  version?: Maybe<Scalars['String']>;
};

export type LockersystemUserPermission = {
  __typename?: 'LockersystemUserPermission';
  accessDenied?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type LockersystemUserPermissionsQuery = {
  includeAdmins?: InputMaybe<Scalars['Boolean']>;
  lockersystemId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};

export type LockersystemsConnection = {
  __typename?: 'LockersystemsConnection';
  lockersystems?: Maybe<Array<Maybe<Lockersystem>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token?: Maybe<Scalars['String']>;
};

export enum Loglevel {
  Debug = 'Debug',
  Error = 'Error',
  Info = 'Info',
  Warning = 'Warning'
}

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success?: Maybe<Scalars['Boolean']>;
  viewer?: Maybe<Viewer>;
};

export type LokerAccessFeedbacksQuery = {
  accessType?: InputMaybe<AccessType>;
  end?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  master?: InputMaybe<Scalars['Boolean']>;
  minResponseTime?: InputMaybe<Scalars['Int']>;
  offlineDecision?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlineDecision?: InputMaybe<Scalars['Boolean']>;
  onlineRelease?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceReportInput = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  minAlertEvents?: InputMaybe<Scalars['Int']>;
  minStuckEvents?: InputMaybe<Scalars['Int']>;
  minTotalEvents?: InputMaybe<Scalars['Int']>;
};

export type MakeItemRentableResponse = {
  __typename?: 'MakeItemRentableResponse';
  item: Item;
  locker: Locker;
  success: Scalars['Boolean'];
};

export type MasterCard = {
  __typename?: 'MasterCard';
  cardNumber: Scalars['String'];
  firstSeenAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inWhitelist: Scalars['Boolean'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  lockersystem: Lockersystem;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<MasterCardType>;
};

export enum MasterCardType {
  Hardware = 'Hardware',
  Software = 'Software'
}

export type MasterWhitelist = {
  __typename?: 'MasterWhitelist';
  cards: Array<MasterCard>;
  id: Scalars['ID'];
  version: Scalars['Int'];
};

export type MasterWhitelistBoardStatus = {
  __typename?: 'MasterWhitelistBoardStatus';
  expectedVersion?: Maybe<Scalars['Int']>;
  matchingBoards: Scalars['Int'];
  mismatchedBoards: Scalars['Int'];
  unknownBoards: Scalars['Int'];
};

export type MasterfeedQuery = {
  card?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  end?: InputMaybe<Scalars['DateTime']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type MasterfeedRow = AccesslistChange | GateNodeEvent | LockerAccessFeedback | LockerHistoryEvent;

export enum MessageDirection {
  Recv = 'Recv',
  Send = 'Send'
}

export type MonthlyRentingStatisticsRow = {
  __typename?: 'MonthlyRentingStatisticsRow';
  bucketStart: Scalars['DateTime'];
  rentingsCount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateGate?: Maybe<Scalars['Boolean']>;
  activateQrReservationKey: QrReservationKey;
  addAccessGroupAccess: AddAccessGroupAccessResponse;
  addGateToGateGroup: AddGateToGateGroupResponse;
  addLockersToAccessGroup?: Maybe<AddLockersToAccessGroupResponse>;
  addLockersToLockerGroup: AddLockersToLockerGroupResponse;
  addLockersystemPermissionForUser: AddLockersystemPermissionForUserResponse;
  addPageView: Scalars['Boolean'];
  addPanelNote: AddPanelNoteResponse;
  addUserDoorcontrolPermission: AddUserDoorcontrolPermissionResponse;
  addUserGroupLockersystemPermission: AddUserGroupLockersystemPermissionResponse;
  addUserLockerPermission: AddUserLockerPermissionResponse;
  addUserToAccesslist: AddUserToAccesslistResponse;
  addUserToUserGroup: Scalars['Boolean'];
  allowLockersystemAccess: AllowLockersystemAccessResponse;
  allowRenting: AllowRentingResponse;
  beginPasskeyLogin: BeginPasskeyLoginResponse;
  beginPasskeyRegistration: BeginPasskeyRegistrationResponse;
  blockDoorcontrol: BlockDoorcontrolResponse;
  calibrateLockers: CalibrateLockersResponse;
  cancelJob: CancelJobResponse;
  cancelRenting: CancelRentingResponse;
  cancelScheduledLockerProgramUpdate: CancelScheduledLockerProgramUpdateResponse;
  changeNode?: Maybe<ChangeNodeResponse>;
  changeUserDefaultLanguage?: Maybe<ChangeLanguageResponse>;
  changeUserPassword: ChangeUserPasswordResponse;
  checkSeitaUpdates?: Maybe<CheckSeitaUpdatesResponse>;
  clearLockersystemHistory: ClearLockersystemHistoryResponse;
  clearLockersystemState: ClearLockersystemStateResponse;
  closeSales: CloseSalesResponse;
  configureLockerNodes: ConfigureLockerNodesResponse;
  connectDoorcontrolToLockersystem: ConnectDoorcontrolToLockersystemResponse;
  copyItem: CopyItemResponse;
  createAccessGroup: CreateAccessGroupResponse;
  createAccesslist: CreateAccesslistResponse;
  createCardKeys: CreateCardKeysResponse;
  createCostTable?: Maybe<CreateCostTableResponse>;
  createDataExportJob: CreateDataExportJobResponse;
  createDeviceGate: CreateDeviceGateResponse;
  createGateGroup: CreateGateGroupResponse;
  createItem: CreateItemResponse;
  createItemGroup: CreateItemGroupResponse;
  createLockerEvent: CreateLockerEventResponse;
  createLockerGroup: CreateLockerGroupResponse;
  createLockerProgramLabel: CreateLockerProgramLabelResponse;
  createLockersystem: CreateLockersystemResponse;
  createResetToken?: Maybe<CreateResetTokenResponse>;
  createScheduledLockerProgramUpdate: CreateScheduledLockerProgramUpdateResponse;
  createToken: CreateTokenResponse;
  createTokenFromPortalOauthCode: CreateTokenFromPortalOauthCodeResponse;
  createUser: CreateUserResponse;
  createUserGroup: CreateUserGroupResponse;
  declineDoorcontrol: DeclineDoorcontrolResponse;
  declinePermit: DeclinePermitResponse;
  deleteAccessCardUser: DeleteAccessCardUserResponse;
  deleteCardKeys: DeleteCardKeysResponse;
  deleteDoorcontrol: DeleteDoorcontrolResponse;
  deleteItem: DeleteItemResponse;
  deleteItemGroup: DeleteItemGroupResponse;
  deleteJob: DeleteJobResponse;
  deleteLockerProgram: DeleteLockerProgramResponse;
  deleteLockerProgramLabel: DeleteLockerProgramLabelResponse;
  deleteMasterCard: Scalars['Boolean'];
  deleteUserGroup: Scalars['Boolean'];
  deliverItemToUser: DeliverItemToUserResponse;
  denyLockersystemAccess: DenyLockersystemAccessResponse;
  disconnectDoorcontrol: DisconnectDoorcontrolResponse;
  editAccessListUser: EditAccessListUserResponse;
  factoryResetLocker: FactoryResetLockerResponse;
  fetchNodeInfo?: Maybe<FetchNodeInfoResponse>;
  finishPasskeyLogin: FinishPasskeyLoginResponse;
  finishPasskeyRegistration: FinishPasskeyRegistrationResponse;
  forgetDoorcontrol: ForgetDoorcontrolResponse;
  freepass: FreepassResponse;
  generateQrReservationKey: QrReservationKey;
  generateSimulationDeviceToken: Scalars['String'];
  generateUserApiToken?: Maybe<ApiKey>;
  givePermit: GivePermitResponse;
  hakaUserCallback: HakaUserCallbackResponse;
  interruptDelivery: InterruptDeliveryResponse;
  interruptRenting: InterruptRentingResponse;
  invitePortalUserToLockersystem: InvitePortalUserToLockersystemResponse;
  joinUserToLockersystem: JoinUserToLockersystemResponse;
  login?: Maybe<LoginResponse>;
  logout: LogoutResponse;
  openSales: OpenSalesResponse;
  passivateGate?: Maybe<Scalars['Boolean']>;
  passivateLockersystem: PassivateLockersystemResponse;
  passivateUser?: Maybe<PassivateUserResponse>;
  pickupDeliveredItem: PickupDeliveredItemResponse;
  placeItemToLocker: PlaceItemToLockerResponse;
  powerlinkReboot?: Maybe<PowerlinkRebootResponse>;
  rebootSeita?: Maybe<RebootSeitaResponse>;
  registerFcm: RegisterFcmResponse;
  registerPhoneWithGoogleIdToken: RegisterPhoneWithGoogleTokenResponse;
  registerPhoneWithSamlAuthCode: RegisterPhoneWithSamlAuthCodeResponse;
  remoteOpenLocker: RemoteOpenLockerResponse;
  removeAccessGroup: RemoveAccessGroupResponse;
  removeAccessGroupAccess: RemoveAccessGroupAccessResponse;
  removeAccesslist: RemoveAccesslistResponse;
  removeArea: RemoveAreaResponse;
  removeCardFromAccesslist: RemoveCardFromAccesslistResponse;
  removeCompanyAreas: Scalars['Boolean'];
  removeCompanyGateEvents: Scalars['Boolean'];
  removeDeviceGate: RemoveDeviceGateResponse;
  removeGate: RemoveGateResponse;
  removeGateEntity: RemoveGateEntityResponse;
  removeGateFromGateGroup: RemoveGateFromGateGroupResponse;
  removeGateGroup: RemoveGateGroupResponse;
  removeItemFromLocker: RemoveItemFromLockerResponse;
  removeLockerFromAccessGroup?: Maybe<Scalars['Boolean']>;
  removeLockerGroup: RemoveLockerGroupResponse;
  removeLockersFromLockerGroup: RemoveLockersFromLockerGroupResponse;
  removeLockersystemPermission: RemoveLockersystemPermissionResponse;
  removePasskey: RemovePasskeyResponse;
  removeTranslation: RemoveTranslationResponse;
  removeUser?: Maybe<RemoveUserResponse>;
  removeUserApiToken?: Maybe<Scalars['Boolean']>;
  removeUserDoorcontrolPermission: RemoveUserDoorcontrolPermissionResponse;
  removeUserFromUserGroup: Scalars['Boolean'];
  removeUserGroupLockersystemPermission: RemoveUserGroupLockersystemPermissionResponse;
  removeUserLockerPermission: RemoveUserLockerPermissionResponse;
  rentItem: RentItemResponse;
  replaceLockerProgramBinary: ReplaceLockerProgramBinaryResponse;
  requestLockerHistory: Scalars['Boolean'];
  requestLockerStatus: Scalars['Boolean'];
  resetGateCounters: Scalars['Boolean'];
  retireQrReservationKey: QrReservationKey;
  returnRentedItem: ReturnRentedItemResponse;
  revokeUserSession: RevokeUserSessionResponse;
  saveTestReport: SaveTestReportResponse;
  sendCardKeys: SendCardKeysResponse;
  sendConfigToDoorcontrol: SendConfigToDoorcontrolResponse;
  sendDelivery: SendDeliveryResponse;
  sendDoormapToLockerNodes: SendDoormapToLockerNodesResponse;
  sendDoormapToLockers: SendDoormapToLockersResponse;
  sendEmail: SendEmailResponse;
  sendFeedback: SendFeedbackResponse;
  sendLockerUpdateEndFrame: SendLockerUpdateEndFrameResponse;
  sendLockersystemMasterWhitelist: SendLockersystemMasterWhitelistResponse;
  sendMasterPincode: Scalars['Boolean'];
  sendRentingLateReminder: SendRentingLateReminderResponse;
  sendSeitaCmd?: Maybe<SendSeitaCmdResponse>;
  sendSeitaLogs?: Maybe<SendSeitaLogsResponse>;
  sendTestTranslationEmail: SendTestTranslationEmailResponse;
  setAudioMode?: Maybe<SetAudioModeResponse>;
  setDoorAccess?: Maybe<SetDoorAccessResponse>;
  setGateName?: Maybe<Scalars['Boolean']>;
  setHallTestMode?: Maybe<SetHallTestModeResponse>;
  setLockersystemMasterWhitelist: SetLockersystemMasterWhitelistResponse;
  setMasterWhitelist?: Maybe<SetMasterWhitelistResponse>;
  setOutOfOrderMode?: Maybe<SetOutOfOrderModeResponse>;
  setPanelId?: Maybe<SetPanelIdResponse>;
  setupLockersystem: SetupLockersystemResponse;
  stopLockerUpdate: StopLockerUpdateResponse;
  testBreakInAlarm: BreakInAlarm;
  transferRenting: TransferRentingResponse;
  unblockDoorcontrol: UnblockDoorcontrolResponse;
  updateAccessGroup: UpdateAccessGroupResponse;
  updateAccessGroupAccess: UpdateAccessGroupAccessResponse;
  updateAccesslist: UpdateAccesslistResponse;
  updateCostTable?: Maybe<UpdateCostTableResponse>;
  updateDelivery: UpdateDeliveryResponse;
  updateDeviceGate: UpdateDeviceGateResponse;
  updateDoorcontrol: UpdateDoorcontrolResponse;
  updateDoorcontrolSelf: UpdateDoorcontrolSelfResponse;
  updateDoormap: UpdateDoormapResponse;
  updateGateNode: UpdateGateNodeResponse;
  updateItem: UpdateItemResponse;
  updateItemGroup: UpdateItemGroupResponse;
  updateLocker: UpdateLockerResponse;
  updateLockerBoardStatus: UpdateLockerBoardStatusResponse;
  updateLockerGroup: UpdateLockerGroupResponse;
  updateLockerProgram: UpdateLockerProgramResponse;
  updateLockerProgramLabel: UpdateLockerProgramLabelResponse;
  updateLockerProgramMetadata: UpdateLockerProgramMetadataResponse;
  updateLockerStates: UpdateLockerStatesResponse;
  updateLockers: UpdateLockersResponse;
  updateLockersystem: UpdateLockersystemResponse;
  updateLockersystemAccessGroups: UpdateLockersystemAccessGroupsResponse;
  updateLockersystemLockerGroups: UpdateLockersystemLockerGroupsResponse;
  updateLockersystemPermission: UpdateLockersystemPermissionResponse;
  updateMasterCardName: MasterCard;
  updateRenting: UpdateRentingResponse;
  updateServerSettings: UpdateServerSettingsResponse;
  updateTranslation: UpdateTranslationResponse;
  updateUser: UpdateUserResponse;
  updateUserGroup: UpdateUserGroupResponse;
  updateUserGroupLockersystemPermission: UpdateUserGroupLockersystemPermissionResponse;
  uploadDoormap: UploadDoormapResponse;
  uploadLockerProgram: UploadLockerProgramResponse;
  useLainaamoCode: UseLainaamoCodeResponse;
};


export type MutationActivateGateArgs = {
  gateId: Scalars['ID'];
};


export type MutationActivateQrReservationKeyArgs = {
  id: Scalars['ID'];
};


export type MutationAddAccessGroupAccessArgs = {
  input: AddAccessGroupAccess;
};


export type MutationAddGateToGateGroupArgs = {
  gateGroupId: Scalars['ID'];
  gateId: Scalars['ID'];
  position: Scalars['Int'];
};


export type MutationAddLockersToAccessGroupArgs = {
  accessGroupName: Scalars['String'];
  endLockerNumber?: InputMaybe<Scalars['Int']>;
  lockers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  startLockerNumber?: InputMaybe<Scalars['Int']>;
};


export type MutationAddLockersToLockerGroupArgs = {
  input: AddLockersToLockerGroup;
};


export type MutationAddLockersystemPermissionForUserArgs = {
  input: AddLockersystemPermissionForUser;
};


export type MutationAddPageViewArgs = {
  url: Scalars['String'];
};


export type MutationAddPanelNoteArgs = {
  input: AddPanelNoteInput;
};


export type MutationAddUserDoorcontrolPermissionArgs = {
  input: AddUserDoorcontrolPermission;
};


export type MutationAddUserGroupLockersystemPermissionArgs = {
  input: AddUserGroupLockersystemPermission;
};


export type MutationAddUserLockerPermissionArgs = {
  input: AddUserLockerPermission;
};


export type MutationAddUserToAccesslistArgs = {
  input: AddUserToAccesslist;
};


export type MutationAddUserToUserGroupArgs = {
  input: UserGroupUserInput;
};


export type MutationAllowLockersystemAccessArgs = {
  input: AllowLockersystemAccess;
};


export type MutationAllowRentingArgs = {
  input: AllowRenting;
};


export type MutationBeginPasskeyRegistrationArgs = {
  input: BeginPasskeyRegistrationInput;
};


export type MutationBlockDoorcontrolArgs = {
  input: BlockDoorcontrol;
};


export type MutationCalibrateLockersArgs = {
  input: CalibrateLockers;
};


export type MutationCancelJobArgs = {
  id: Scalars['ID'];
};


export type MutationCancelRentingArgs = {
  input: CancelRenting;
};


export type MutationCancelScheduledLockerProgramUpdateArgs = {
  input: CancelScheduledLockerProgramUpdate;
};


export type MutationChangeNodeArgs = {
  input: ChangeNode;
};


export type MutationChangeUserDefaultLanguageArgs = {
  input: ChangeLanguage;
};


export type MutationChangeUserPasswordArgs = {
  input: ChangeUserPassword;
};


export type MutationCheckSeitaUpdatesArgs = {
  input: CheckSeitaUpdates;
};


export type MutationClearLockersystemHistoryArgs = {
  input?: InputMaybe<ClearLockersystemHistory>;
};


export type MutationClearLockersystemStateArgs = {
  input?: InputMaybe<ClearLockersystemState>;
};


export type MutationCloseSalesArgs = {
  input: CloseSales;
};


export type MutationConfigureLockerNodesArgs = {
  input: ConfigureLockerNodes;
};


export type MutationConnectDoorcontrolToLockersystemArgs = {
  input: ConnectDoorcontrolToLockersystem;
};


export type MutationCopyItemArgs = {
  input: CopyItem;
};


export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroup;
};


export type MutationCreateAccesslistArgs = {
  input: CreateAccesslist;
};


export type MutationCreateCardKeysArgs = {
  input: CreateCardKeys;
};


export type MutationCreateCostTableArgs = {
  input: CreateCostTable;
};


export type MutationCreateDataExportJobArgs = {
  input: CreateDataExportJobInput;
};


export type MutationCreateDeviceGateArgs = {
  input: CreateDeviceGate;
};


export type MutationCreateGateGroupArgs = {
  gateGroupName: Scalars['String'];
};


export type MutationCreateItemArgs = {
  input: CreateItem;
};


export type MutationCreateItemGroupArgs = {
  input: CreateItemGroup;
};


export type MutationCreateLockerEventArgs = {
  input: CreateLockerEventInput;
};


export type MutationCreateLockerGroupArgs = {
  input: CreateLockerGroup;
};


export type MutationCreateLockerProgramLabelArgs = {
  input: CreateLockerProgramLabel;
};


export type MutationCreateLockersystemArgs = {
  input: CreateLockersystem;
};


export type MutationCreateResetTokenArgs = {
  userId: Scalars['ID'];
};


export type MutationCreateScheduledLockerProgramUpdateArgs = {
  input: CreateScheduledLockerProgramUpdate;
};


export type MutationCreateTokenArgs = {
  apiKey: Scalars['String'];
};


export type MutationCreateTokenFromPortalOauthCodeArgs = {
  input: CreateTokenFromPortalOauthCode;
};


export type MutationCreateUserArgs = {
  input: CreateUser;
};


export type MutationCreateUserGroupArgs = {
  input: CreateUserGroup;
};


export type MutationDeclineDoorcontrolArgs = {
  input: DeclineDoorcontrol;
};


export type MutationDeclinePermitArgs = {
  input: DeclinePermit;
};


export type MutationDeleteAccessCardUserArgs = {
  input: DeleteAccessCardUser;
};


export type MutationDeleteCardKeysArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDoorcontrolArgs = {
  input: DeleteDoorcontrol;
};


export type MutationDeleteItemArgs = {
  input: DeleteItem;
};


export type MutationDeleteItemGroupArgs = {
  input: DeleteItemGroup;
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLockerProgramArgs = {
  input: DeleteLockerProgram;
};


export type MutationDeleteLockerProgramLabelArgs = {
  input: DeleteLockerProgramLabel;
};


export type MutationDeleteMasterCardArgs = {
  input: DeleteMasterCardInput;
};


export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars['ID'];
};


export type MutationDeliverItemToUserArgs = {
  input?: InputMaybe<DeliverItemToUser>;
};


export type MutationDenyLockersystemAccessArgs = {
  input: DenyLockersystemAccess;
};


export type MutationDisconnectDoorcontrolArgs = {
  input: DisconnectDoorcontrol;
};


export type MutationEditAccessListUserArgs = {
  input: EditAccessListUser;
};


export type MutationFactoryResetLockerArgs = {
  input: FactoryResetLocker;
};


export type MutationFetchNodeInfoArgs = {
  input: FetchNodeInfo;
};


export type MutationFinishPasskeyLoginArgs = {
  input: FinishPasskeyLoginInput;
};


export type MutationFinishPasskeyRegistrationArgs = {
  input: FinishPasskeyRegistrationInput;
};


export type MutationForgetDoorcontrolArgs = {
  input: ForgetDoorcontrol;
};


export type MutationFreepassArgs = {
  input: Freepass;
};


export type MutationGenerateQrReservationKeyArgs = {
  lockersystemId: Scalars['ID'];
};


export type MutationGenerateSimulationDeviceTokenArgs = {
  deviceNumber: Scalars['ID'];
};


export type MutationGenerateUserApiTokenArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationGivePermitArgs = {
  input: GivePermit;
};


export type MutationHakaUserCallbackArgs = {
  input: HakaUserCallback;
};


export type MutationInterruptDeliveryArgs = {
  input: InterruptDelivery;
};


export type MutationInterruptRentingArgs = {
  input: InterruptRenting;
};


export type MutationInvitePortalUserToLockersystemArgs = {
  input: InvitePortalUserToLockersystem;
};


export type MutationJoinUserToLockersystemArgs = {
  input: JoinUserToLockersystem;
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  userName: Scalars['String'];
};


export type MutationOpenSalesArgs = {
  input: OpenSales;
};


export type MutationPassivateGateArgs = {
  gateId: Scalars['ID'];
};


export type MutationPassivateLockersystemArgs = {
  input: PassivateLockersystem;
};


export type MutationPassivateUserArgs = {
  input: PassivateUser;
};


export type MutationPickupDeliveredItemArgs = {
  input: PickupDeliveredItem;
};


export type MutationPlaceItemToLockerArgs = {
  input: PlaceItemToLocker;
};


export type MutationPowerlinkRebootArgs = {
  input: PowerlinkReboot;
};


export type MutationRebootSeitaArgs = {
  input: RebootSeita;
};


export type MutationRegisterFcmArgs = {
  token: Scalars['String'];
};


export type MutationRegisterPhoneWithGoogleIdTokenArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  googleIdToken: Scalars['String'];
  model: Scalars['String'];
  os: PhoneOs;
  versionCode?: InputMaybe<Scalars['Int']>;
  versionName?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterPhoneWithSamlAuthCodeArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  os: PhoneOs;
  samlAuthCode: Scalars['String'];
  versionCode?: InputMaybe<Scalars['Int']>;
  versionName?: InputMaybe<Scalars['String']>;
};


export type MutationRemoteOpenLockerArgs = {
  input: RemoteOpenLocker;
};


export type MutationRemoveAccessGroupArgs = {
  input: RemoveAccessGroup;
};


export type MutationRemoveAccessGroupAccessArgs = {
  input: RemoveAccessGroupAccess;
};


export type MutationRemoveAccesslistArgs = {
  input: RemoveAccesslist;
};


export type MutationRemoveAreaArgs = {
  input: RemoveArea;
};


export type MutationRemoveCardFromAccesslistArgs = {
  input: RemoveCardFromAccesslist;
};


export type MutationRemoveCompanyAreasArgs = {
  input: RemoveCompanyAreas;
};


export type MutationRemoveCompanyGateEventsArgs = {
  input: RemoveCompanyGateEvents;
};


export type MutationRemoveDeviceGateArgs = {
  input: RemoveDeviceGate;
};


export type MutationRemoveGateArgs = {
  input: RemoveGate;
};


export type MutationRemoveGateEntityArgs = {
  input: RemoveGateEntity;
};


export type MutationRemoveGateFromGateGroupArgs = {
  gateGroupId: Scalars['ID'];
  gateId: Scalars['ID'];
};


export type MutationRemoveGateGroupArgs = {
  gateGroupId: Scalars['ID'];
};


export type MutationRemoveItemFromLockerArgs = {
  input: RemoveItemFromLocker;
};


export type MutationRemoveLockerFromAccessGroupArgs = {
  accessGroupName: Scalars['String'];
  lockerNumber: Scalars['Int'];
};


export type MutationRemoveLockerGroupArgs = {
  input: RemoveLockerGroup;
};


export type MutationRemoveLockersFromLockerGroupArgs = {
  input: RemoveLockersFromLockerGroup;
};


export type MutationRemoveLockersystemPermissionArgs = {
  input: RemoveLockersystemPermission;
};


export type MutationRemovePasskeyArgs = {
  input: RemovePasskeyInput;
};


export type MutationRemoveTranslationArgs = {
  input: RemoveTranslation;
};


export type MutationRemoveUserArgs = {
  input: RemoveUser;
};


export type MutationRemoveUserApiTokenArgs = {
  apiToken: Scalars['String'];
};


export type MutationRemoveUserDoorcontrolPermissionArgs = {
  input: RemoveUserDoorcontrolPermission;
};


export type MutationRemoveUserFromUserGroupArgs = {
  input: UserGroupUserInput;
};


export type MutationRemoveUserGroupLockersystemPermissionArgs = {
  input: RemoveUserGroupLockersystemPermission;
};


export type MutationRemoveUserLockerPermissionArgs = {
  input: RemoveUserLockerPermission;
};


export type MutationRentItemArgs = {
  input: RentItem;
};


export type MutationReplaceLockerProgramBinaryArgs = {
  input: ReplaceLockerProgramBinary;
};


export type MutationRequestLockerHistoryArgs = {
  input: RequestLockerHistory;
};


export type MutationRequestLockerStatusArgs = {
  input?: InputMaybe<RequestLockerStatus>;
};


export type MutationResetGateCountersArgs = {
  input: ResetGateCounters;
};


export type MutationRetireQrReservationKeyArgs = {
  id: Scalars['ID'];
};


export type MutationReturnRentedItemArgs = {
  input: ReturnRentedItem;
};


export type MutationRevokeUserSessionArgs = {
  input: RevokeUserSession;
};


export type MutationSaveTestReportArgs = {
  input: SaveTestReportInput;
};


export type MutationSendCardKeysArgs = {
  input: SendCardKeys;
};


export type MutationSendConfigToDoorcontrolArgs = {
  input: SendConfigToDoorcontrol;
};


export type MutationSendDeliveryArgs = {
  input: SendDelivery;
};


export type MutationSendDoormapToLockerNodesArgs = {
  input: SendDoormapToLockerNodes;
};


export type MutationSendDoormapToLockersArgs = {
  input: SendDoormapToLockers;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationSendFeedbackArgs = {
  input: SendFeedback;
};


export type MutationSendLockerUpdateEndFrameArgs = {
  input: SendLockerUpdateEndFrame;
};


export type MutationSendLockersystemMasterWhitelistArgs = {
  input: SendLockersystemMasterWhitelistInput;
};


export type MutationSendMasterPincodeArgs = {
  input: SendMasterPincode;
};


export type MutationSendRentingLateReminderArgs = {
  input: SendRentingLateReminderInput;
};


export type MutationSendSeitaCmdArgs = {
  input: SendSeitaCmd;
};


export type MutationSendSeitaLogsArgs = {
  input: SendSeitaLogs;
};


export type MutationSendTestTranslationEmailArgs = {
  input: SendTestTranslationEmailInput;
};


export type MutationSetAudioModeArgs = {
  input: SetAudioMode;
};


export type MutationSetDoorAccessArgs = {
  input: SetDoorAccess;
};


export type MutationSetGateNameArgs = {
  gateId: Scalars['ID'];
  gateName: Scalars['String'];
};


export type MutationSetHallTestModeArgs = {
  input: SetHallTestMode;
};


export type MutationSetLockersystemMasterWhitelistArgs = {
  input: SetLockersystemMasterWhitelistInput;
};


export type MutationSetMasterWhitelistArgs = {
  input: SetMasterWhitelist;
};


export type MutationSetOutOfOrderModeArgs = {
  input: SetOutOfOrderMode;
};


export type MutationSetPanelIdArgs = {
  input: SetPanelId;
};


export type MutationSetupLockersystemArgs = {
  input: SetupLockersystem;
};


export type MutationStopLockerUpdateArgs = {
  input: StopLockerUpdate;
};


export type MutationTestBreakInAlarmArgs = {
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId: Scalars['ID'];
};


export type MutationTransferRentingArgs = {
  input: TransferRenting;
};


export type MutationUnblockDoorcontrolArgs = {
  input: UnblockDoorcontrol;
};


export type MutationUpdateAccessGroupArgs = {
  input: UpdateAccessGroup;
};


export type MutationUpdateAccessGroupAccessArgs = {
  input: UpdateAccessGroupAccess;
};


export type MutationUpdateAccesslistArgs = {
  input: UpdateAccesslist;
};


export type MutationUpdateCostTableArgs = {
  input: UpdateCostTable;
};


export type MutationUpdateDeliveryArgs = {
  input: UpdateDelivery;
};


export type MutationUpdateDeviceGateArgs = {
  input: UpdateDeviceGate;
};


export type MutationUpdateDoorcontrolArgs = {
  input: UpdateDoorcontrol;
};


export type MutationUpdateDoorcontrolSelfArgs = {
  input: UpdateDoorcontrolSelf;
};


export type MutationUpdateDoormapArgs = {
  input: UpdateDoormap;
};


export type MutationUpdateGateNodeArgs = {
  input: UpdateGateNode;
};


export type MutationUpdateItemArgs = {
  input: UpdateItem;
};


export type MutationUpdateItemGroupArgs = {
  input: UpdateItemGroup;
};


export type MutationUpdateLockerArgs = {
  input: UpdateLocker;
};


export type MutationUpdateLockerBoardStatusArgs = {
  input: UpdateLockerBoardStatusInput;
};


export type MutationUpdateLockerGroupArgs = {
  input: UpdateLockerGroup;
};


export type MutationUpdateLockerProgramArgs = {
  input: UpdateLockerProgram;
};


export type MutationUpdateLockerProgramLabelArgs = {
  input: UpdateLockerProgramLabel;
};


export type MutationUpdateLockerProgramMetadataArgs = {
  input: UpdateLockerProgramMetadata;
};


export type MutationUpdateLockerStatesArgs = {
  input: UpdateLockerStates;
};


export type MutationUpdateLockersArgs = {
  input: UpdateLockers;
};


export type MutationUpdateLockersystemArgs = {
  input: UpdateLockersystem;
};


export type MutationUpdateLockersystemAccessGroupsArgs = {
  input: UpdateLockersystemAccessGroups;
};


export type MutationUpdateLockersystemLockerGroupsArgs = {
  input: UpdateLockersystemLockerGroups;
};


export type MutationUpdateLockersystemPermissionArgs = {
  input: UpdateLockersystemPermission;
};


export type MutationUpdateMasterCardNameArgs = {
  input: UpdateMasterCardNameInput;
};


export type MutationUpdateRentingArgs = {
  input: UpdateRenting;
};


export type MutationUpdateServerSettingsArgs = {
  input: UpdateServerSettingsInput;
};


export type MutationUpdateTranslationArgs = {
  input: UpdateTranslation;
};


export type MutationUpdateUserArgs = {
  input: UpdateUser;
};


export type MutationUpdateUserGroupArgs = {
  input: UpdateUserGroup;
};


export type MutationUpdateUserGroupLockersystemPermissionArgs = {
  input: UpdateUserGroupLockersystemPermission;
};


export type MutationUploadDoormapArgs = {
  input: UploadDoormap;
};


export type MutationUploadLockerProgramArgs = {
  input: UploadLockerProgram;
};


export type MutationUseLainaamoCodeArgs = {
  code: Scalars['String'];
};

export type NewAccessGroup = {
  name: Scalars['String'];
  tempId: Scalars['ID'];
};

export type NewLockerGroup = {
  name: Scalars['String'];
  tempId: Scalars['ID'];
};

export enum NfcAction {
  AuthenticateUser = 'AuthenticateUser',
  None = 'None',
  SendLainaamoCode = 'SendLainaamoCode',
  ShowLockedDoors = 'ShowLockedDoors',
  Storage = 'Storage'
}

export type NodeConnection = {
  __typename?: 'NodeConnection';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  gateId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  nodeId?: Maybe<Scalars['ID']>;
};

export type NodeInfo = {
  __typename?: 'NodeInfo';
  applicationId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  doorcontrol?: Maybe<Doorcontrol>;
  doorcontrolId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  nodeId?: Maybe<Scalars['Int']>;
  panel?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type NodeInfoQuery = {
  deviceNumber?: InputMaybe<Scalars['ID']>;
  doorcontrolId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['Int']>;
};

export enum Order_By_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Order_Direction {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type OpenLocker = {
  lockerId: Scalars['ID'];
};

export type OpenLockerResponse = {
  __typename?: 'OpenLockerResponse';
  locker: Locker;
  openCode: Scalars['String'];
};

export type OpenSales = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  gateId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['ID']>;
  openingMode?: InputMaybe<Scalars['String']>;
  saleperson?: InputMaybe<Scalars['String']>;
  saleplace?: InputMaybe<Scalars['String']>;
};

export type OpenSalesResponse = {
  __typename?: 'OpenSalesResponse';
  affectedNodes?: Maybe<Scalars['Int']>;
  nodes: Array<GateNode>;
};

export enum OutOfOrderModeCmd {
  HoldClosed = 'HoldClosed',
  HoldOpen = 'HoldOpen',
  Normal = 'Normal'
}

export enum Outcome {
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  Other = 'Other',
  Success = 'Success'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PageViewStatRow = {
  __typename?: 'PageViewStatRow';
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
  useTimes?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type PageViewStatRowsConnection = {
  __typename?: 'PageViewStatRowsConnection';
  pageViewStatRows?: Maybe<Array<Maybe<PageViewStatRow>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Panel = {
  __typename?: 'Panel';
  boards: Array<LockerBoard>;
  createdAt: Scalars['DateTime'];
  doorcontrol?: Maybe<Doorcontrol>;
  doorcontrolId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  notes: Array<PanelNote>;
  panelId?: Maybe<Scalars['Int']>;
  panelType?: Maybe<Scalars['Int']>;
};

export type PanelNote = {
  __typename?: 'PanelNote';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
};

export type PanelsConnection = {
  __typename?: 'PanelsConnection';
  panels: Array<Panel>;
  totalCount: Scalars['Int'];
};

export type PanelsQuery = {
  doorcontrolDeviceNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  panelIdentifier?: InputMaybe<Scalars['Int']>;
  panelType?: InputMaybe<Scalars['Int']>;
};

export type PassivateLockersystem = {
  lockersystemId: Scalars['ID'];
};

export type PassivateLockersystemResponse = {
  __typename?: 'PassivateLockersystemResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type PassivateUser = {
  userId: Scalars['ID'];
};

export type PassivateUserResponse = {
  __typename?: 'PassivateUserResponse';
  user?: Maybe<User>;
};

export enum PassivatedState {
  All = 'ALL',
  NotPassivated = 'NOT_PASSIVATED',
  Passivated = 'PASSIVATED'
}

export type Passkey = {
  __typename?: 'Passkey';
  backedUp: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  transports: Array<Scalars['String']>;
};

export type Phone = {
  __typename?: 'Phone';
  id?: Maybe<Scalars['ID']>;
  lockedLockerNumbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lockedLockers?: Maybe<Array<Maybe<Locker>>>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<PhoneOs>;
};

export enum PhoneOs {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PhoneViewer = {
  __typename?: 'PhoneViewer';
  phone?: Maybe<Phone>;
  user?: Maybe<User>;
};

export type PickupDeliveredItem = {
  deliveryId: Scalars['ID'];
};

export type PickupDeliveredItemResponse = {
  __typename?: 'PickupDeliveredItemResponse';
  code: Scalars['String'];
  delivery: Delivery;
  locker: Locker;
};

export type PlaceItemToLocker = {
  itemId: Scalars['ID'];
  lockerId: Scalars['ID'];
};

export type PlaceItemToLockerResponse = {
  __typename?: 'PlaceItemToLockerResponse';
  item: Item;
};

export type PortalUser = {
  __typename?: 'PortalUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type PowerlinkReboot = {
  deviceNumber: Scalars['ID'];
};

export type PowerlinkRebootResponse = {
  __typename?: 'PowerlinkRebootResponse';
  status?: Maybe<CommandStatus>;
};

export enum QrAction {
  None = 'None',
  SignedStorage = 'SignedStorage',
  Storage = 'Storage'
}

export type QrReservationKey = {
  __typename?: 'QrReservationKey';
  activatedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  keyId: Scalars['Int'];
  lockersystemId: Scalars['ID'];
  retiredAt?: Maybe<Scalars['DateTime']>;
  status: QrReservationKeyStatus;
  updatedAt: Scalars['DateTime'];
  verifyUntil?: Maybe<Scalars['DateTime']>;
};

export enum QrReservationKeyStatus {
  Active = 'Active',
  Pending = 'Pending',
  Retired = 'Retired',
  VerifyOnly = 'VerifyOnly'
}

export type Query = {
  __typename?: 'Query';
  accessGroup?: Maybe<AccessGroup>;
  accessGroupLockers: AccessGroupLockersConnection;
  accessGroups: AccessGroupsConnection;
  accesslist?: Maybe<Accesslist>;
  accesslistChanges: Array<AccesslistChange>;
  accesslistUsers: Array<User>;
  accesslists: AccesslistsConnection;
  allAccessGroups: AllAccessGroupsConnection;
  cardAccesslists: Array<Accesslist>;
  cardKeys: Array<CardKey>;
  cardLockedLockers: Array<Locker>;
  costTables: Array<CostTable>;
  deliveries: DeliveriesConnection;
  delivery?: Maybe<Delivery>;
  deviceGates: Array<DeviceGate>;
  doorNotes: Array<DoorNote>;
  doorcontrol?: Maybe<Doorcontrol>;
  doorcontrolEventsSearch: DoorcontrolEventsConnection;
  doorcontrolLockerNodes: Array<LockerNode>;
  doorcontrolUserPermissions: Array<UserDoorcontrolPermission>;
  doorcontrols: DoorcontrolsConnection;
  eventLogs: EventLogsConnection;
  gateGroup?: Maybe<GateGroup>;
  gateGroupGates: GateGroupGatesConnection;
  gateNode?: Maybe<GateNode>;
  gateNodeEvents: GateNodeEventsConnection;
  gateNodes: GateNodesConnection;
  gateSystems: Array<CompanyGateState>;
  incomeStatistics: Array<IncomeStatisticsRow>;
  item?: Maybe<Item>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroups: ItemGroupsConnection;
  items: ItemsConnection;
  job?: Maybe<Job>;
  jobs: Array<Job>;
  lainaamoUsage: Array<LainaamoUsageRow>;
  lockedLockers: Array<Locker>;
  locker?: Maybe<Locker>;
  lockerAccessFeedbacks: Array<LockerAccessFeedback>;
  lockerBoard?: Maybe<LockerBoard>;
  lockerBoards: LockerBoardsConnection;
  lockerDailyStatistics: Array<LockerDailyStatisticsRow>;
  lockerGroup?: Maybe<LockerGroup>;
  lockerGroupItems: LockerGroupItemsConnection;
  lockerGroups: Array<LockerGroup>;
  lockerHistoryEvents: Array<LockerHistoryEvent>;
  lockerProgram?: Maybe<LockerProgram>;
  lockerProgramLabels: Array<LockerProgramLabel>;
  lockerPrograms: Array<LockerProgram>;
  lockerStatisticsRows?: Maybe<LockerStatisticsRowsConnection>;
  lockerUserPermissions?: Maybe<Array<Maybe<UserLockerPermission>>>;
  lockerVersions: LockerVersionSummary;
  lockers?: Maybe<LockersConnection>;
  lockersystem?: Maybe<Lockersystem>;
  lockersystemAccesslistUsers: Array<User>;
  lockersystemAdminCodes: Array<DailyAdminCode>;
  lockersystemByUrlId?: Maybe<Lockersystem>;
  lockersystemClusters?: Maybe<LockersystemClustersConnection>;
  lockersystemGateOpenings?: Maybe<Scalars['Int']>;
  lockersystemGates?: Maybe<LockersystemGatesConnection>;
  lockersystemLockerEvents: Array<LockerEvent>;
  lockersystemLockerNodes?: Maybe<LockerNodesConnection>;
  lockersystemRecentEvents: Array<LockersystemRecentEvent>;
  lockersystemSubscriptions: Array<LockersystemSubscription>;
  lockersystemUserPermissions: Array<LockersystemUserPermission>;
  masterCards: Array<MasterCard>;
  masterfeed: Array<MasterfeedRow>;
  monthlyRentingStatistics: Array<MonthlyRentingStatisticsRow>;
  myDoorcontrolPermission?: Maybe<UserDoorcontrolPermission>;
  myLockersystemPermission?: Maybe<LockersystemUserPermission>;
  nodeConnections: Array<NodeConnection>;
  nodeInfos: Array<NodeInfo>;
  offlineLockers: Array<Locker>;
  pageViewStatRows?: Maybe<PageViewStatRowsConnection>;
  panel?: Maybe<Panel>;
  panels: PanelsConnection;
  phone?: Maybe<Phone>;
  phoneViewer: PhoneViewer;
  portalUsersLockersystemAccessPending: Array<PortalUser>;
  qrReservationKeys: Array<QrReservationKey>;
  renting?: Maybe<Renting>;
  rentingStatistics: Array<RentingStatisticsRow>;
  rentings: RentingsConnection;
  reservationStatistics: Array<ReservationStatisticsRow>;
  reservations: ReservationsResponse;
  scheduledLockerProgramUpdates: Array<ScheduledLockerProgramUpdate>;
  searchFeedbacks?: Maybe<SearchFeedbacksConnection>;
  searchGateHistory?: Maybe<GateHistoryConnection>;
  searchLockersystems: SearchLockersystemsConnection;
  serverSettings: ServerSettings;
  testReport?: Maybe<TestReport>;
  testReports: Array<TestReport>;
  transactions: Array<Transaction>;
  usageBuckets: UsageBucketsResult;
  usageOverview: UsageOverview;
  user?: Maybe<User>;
  userApiKeys?: Maybe<Array<Maybe<ApiKey>>>;
  userGroup?: Maybe<UserGroup>;
  userGroups: Array<UserGroup>;
  users: UsersConnection;
  viewer?: Maybe<Viewer>;
  visitorCounts: VisitorQueryResult;
};


export type QueryAccessGroupArgs = {
  accessGroupId: Scalars['ID'];
};


export type QueryAccessGroupLockersArgs = {
  accessGroupName: Scalars['String'];
};


export type QueryAccesslistArgs = {
  accesslistId: Scalars['ID'];
};


export type QueryAccesslistChangesArgs = {
  accesslistId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAccesslistUsersArgs = {
  accesslistId: Scalars['ID'];
  cardnumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  ssn?: InputMaybe<Scalars['String']>;
};


export type QueryAccesslistsArgs = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllAccessGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCardAccesslistsArgs = {
  cardnumber: Scalars['String'];
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryCardLockedLockersArgs = {
  cardnumber: Scalars['String'];
  companyId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryDeliveriesArgs = {
  deliveryUser?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  pickupUser?: InputMaybe<Scalars['String']>;
  skipInvalid?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<DeliveryState>;
};


export type QueryDeliveryArgs = {
  deliveryId: Scalars['ID'];
};


export type QueryDeviceGatesArgs = {
  deviceNumber: Scalars['ID'];
};


export type QueryDoorNotesArgs = {
  query?: InputMaybe<DoorNotesQuery>;
};


export type QueryDoorcontrolArgs = {
  deviceNumber: Scalars['ID'];
};


export type QueryDoorcontrolEventsSearchArgs = {
  input?: InputMaybe<DoorcontrolEventsQuery>;
};


export type QueryDoorcontrolLockerNodesArgs = {
  deviceNumber: Scalars['ID'];
};


export type QueryDoorcontrolUserPermissionsArgs = {
  deviceNumber: Scalars['ID'];
};


export type QueryEventLogsArgs = {
  input?: InputMaybe<EventLogsQueryInput>;
};


export type QueryGateGroupArgs = {
  gateGroupId: Scalars['ID'];
};


export type QueryGateGroupGatesArgs = {
  gateGroupId: Scalars['ID'];
};


export type QueryGateNodeArgs = {
  gateId: Scalars['ID'];
};


export type QueryGateNodeEventsArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  deviceNumber?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventType?: InputMaybe<GateNodeEventType>;
  gateId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  nodeId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGateNodesArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  deviceNumber?: InputMaybe<Scalars['String']>;
  gateId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['ID']>;
};


export type QueryIncomeStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  groupBy: IncomeStatisticsGroupBy;
  lockersystemId: Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryItemArgs = {
  itemId: Scalars['ID'];
};


export type QueryItemGroupArgs = {
  itemGroupId: Scalars['ID'];
};


export type QueryItemGroupsArgs = {
  opt?: InputMaybe<SearchItemGroupsOptions>;
};


export type QueryItemsArgs = {
  opt?: InputMaybe<SearchItemsOptions>;
};


export type QueryJobArgs = {
  id: Scalars['ID'];
};


export type QueryJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryLainaamoUsageArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  groupBy: RentingStatisticsGroupBy;
  lockersystemId: Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryLockedLockersArgs = {
  cardnumber: Scalars['String'];
};


export type QueryLockerArgs = {
  lockerId?: InputMaybe<Scalars['ID']>;
};


export type QueryLockerAccessFeedbacksArgs = {
  query: LokerAccessFeedbacksQuery;
};


export type QueryLockerBoardArgs = {
  id: Scalars['ID'];
};


export type QueryLockerBoardsArgs = {
  input?: InputMaybe<LockerBoardsQuery>;
};


export type QueryLockerDailyStatisticsArgs = {
  days?: InputMaybe<Scalars['Int']>;
  lockerId: Scalars['ID'];
};


export type QueryLockerGroupArgs = {
  lockerGroupId: Scalars['ID'];
};


export type QueryLockerGroupItemsArgs = {
  lockerGroupId: Scalars['ID'];
};


export type QueryLockerGroupsArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryLockerHistoryEventsArgs = {
  query?: InputMaybe<LockerhistoryEventsQuery>;
};


export type QueryLockerProgramArgs = {
  lockerProgramId: Scalars['ID'];
};


export type QueryLockerStatisticsRowsArgs = {
  opt: LockerStatisticsOpt;
};


export type QueryLockerUserPermissionsArgs = {
  lockerId: Scalars['ID'];
};


export type QueryLockerVersionsArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryLockersArgs = {
  opt?: InputMaybe<LockersOpt>;
};


export type QueryLockersystemArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryLockersystemAccesslistUsersArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryLockersystemAdminCodesArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryLockersystemByUrlIdArgs = {
  urlId: Scalars['String'];
};


export type QueryLockersystemClustersArgs = {
  clusterState?: InputMaybe<ClusterState>;
  lockersystemId: Scalars['ID'];
};


export type QueryLockersystemGateOpeningsArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryLockersystemGatesArgs = {
  lockersystemId: Scalars['ID'];
  passivated?: InputMaybe<Scalars['Boolean']>;
  sortOption?: InputMaybe<Gate_Sort_Option>;
};


export type QueryLockersystemLockerEventsArgs = {
  query: LockersystemLockerEventsQuery;
};


export type QueryLockersystemLockerNodesArgs = {
  lockersystemId: Scalars['ID'];
  noLockerUnit?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLockersystemRecentEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId: Scalars['ID'];
};


export type QueryLockersystemUserPermissionsArgs = {
  query?: InputMaybe<LockersystemUserPermissionsQuery>;
};


export type QueryMasterCardsArgs = {
  lockersystemIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMasterfeedArgs = {
  query: MasterfeedQuery;
};


export type QueryMonthlyRentingStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  groupBy: RentingStatisticsGroupBy;
  lockersystemId: Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryMyDoorcontrolPermissionArgs = {
  deviceNumber: Scalars['ID'];
};


export type QueryMyLockersystemPermissionArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryNodeInfosArgs = {
  query: NodeInfoQuery;
};


export type QueryPanelArgs = {
  id: Scalars['ID'];
};


export type QueryPanelsArgs = {
  input?: InputMaybe<PanelsQuery>;
};


export type QueryPhoneArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryPortalUsersLockersystemAccessPendingArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryQrReservationKeysArgs = {
  lockersystemId: Scalars['ID'];
};


export type QueryRentingArgs = {
  rentingId: Scalars['ID'];
};


export type QueryRentingStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  lockersystemId: Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryRentingsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  itemName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerNumber?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  rentingUser?: InputMaybe<Scalars['String']>;
  skipInvalid?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<RentingSortField>;
  start?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<RentingState>;
};


export type QueryReservationStatisticsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  groupBy: ReservationStatisticsGroupBy;
  lockersystemId: Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryReservationsArgs = {
  input: ReservationsSearchOptions;
};


export type QueryScheduledLockerProgramUpdatesArgs = {
  deviceNumber?: InputMaybe<Scalars['ID']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']>;
  includeInterrupted?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchFeedbacksArgs = {
  input?: InputMaybe<FeedbacksQuery>;
};


export type QuerySearchGateHistoryArgs = {
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  gateGroupId?: InputMaybe<Scalars['ID']>;
  gateId?: InputMaybe<Scalars['ID']>;
  lastDay?: InputMaybe<Scalars['Boolean']>;
  lastFiveMinutes?: InputMaybe<Scalars['Boolean']>;
  lastHour?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchLockersystemsArgs = {
  alertsEnabled?: InputMaybe<Scalars['Boolean']>;
  breakinAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  cabinetType?: InputMaybe<LockersystemCabinetType>;
  cabinetTypeUnsigned?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['String']>;
  hasDeliveries?: InputMaybe<Scalars['Boolean']>;
  hasDoorNotes?: InputMaybe<Scalars['Boolean']>;
  hasDoorcontrols?: InputMaybe<Scalars['Boolean']>;
  hasFeedbacks?: InputMaybe<Scalars['Boolean']>;
  hasItems?: InputMaybe<Scalars['Boolean']>;
  hasLockerAccessFeedbacks?: InputMaybe<Scalars['Boolean']>;
  hasRentings?: InputMaybe<Scalars['Boolean']>;
  hasReservations?: InputMaybe<Scalars['Boolean']>;
  hasTransactions?: InputMaybe<Scalars['Boolean']>;
  installationEnd?: InputMaybe<Scalars['DateTime']>;
  installationStart?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchWord?: InputMaybe<Scalars['String']>;
  showPassivated?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTestReportArgs = {
  id: Scalars['ID'];
};


export type QueryTestReportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  reportType?: InputMaybe<TestReportType>;
};


export type QueryTransactionsArgs = {
  options?: InputMaybe<TransactionsSearchOptions>;
};


export type QueryUsageBucketsArgs = {
  query: UsageBucketsQuery;
};


export type QueryUsageOverviewArgs = {
  input: UsageOverviewOpt;
};


export type QueryUserArgs = {
  userId: Scalars['ID'];
};


export type QueryUserApiKeysArgs = {
  userId: Scalars['ID'];
};


export type QueryUserGroupArgs = {
  userGroupId: Scalars['ID'];
};


export type QueryUserGroupsArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserSearchOptions>;
};


export type QueryVisitorCountsArgs = {
  query: VisitorCountsQuery;
};

export type RebootSeita = {
  deviceNumber: Scalars['String'];
};

export type RebootSeitaResponse = {
  __typename?: 'RebootSeitaResponse';
  deviceNumber?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status?: Maybe<CommandStatus>;
};

export type RegisterFcmResponse = {
  __typename?: 'RegisterFcmResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type RegisterPhoneWithGoogleTokenResponse = {
  __typename?: 'RegisterPhoneWithGoogleTokenResponse';
  token: Scalars['String'];
};

export type RegisterPhoneWithSamlAuthCodeResponse = {
  __typename?: 'RegisterPhoneWithSamlAuthCodeResponse';
  token: Scalars['String'];
};

export type RemoteOpenLocker = {
  deviceNumber: Scalars['ID'];
  lockerNumber: Scalars['Int'];
};

export type RemoteOpenLockerResponse = {
  __typename?: 'RemoteOpenLockerResponse';
  locker?: Maybe<Locker>;
};

export type RemoveAccessGroup = {
  accessGroupId: Scalars['ID'];
};

export type RemoveAccessGroupAccess = {
  accessGroupAccessId: Scalars['ID'];
};

export type RemoveAccessGroupAccessResponse = {
  __typename?: 'RemoveAccessGroupAccessResponse';
  accessGroupAccessId: Scalars['ID'];
};

export type RemoveAccessGroupResponse = {
  __typename?: 'RemoveAccessGroupResponse';
  accessGroupId: Scalars['ID'];
};

export type RemoveAccesslist = {
  accesslistId: Scalars['ID'];
};

export type RemoveAccesslistResponse = {
  __typename?: 'RemoveAccesslistResponse';
  accesslistId?: Maybe<Scalars['ID']>;
};

export type RemoveArea = {
  areaId: Scalars['ID'];
  companyId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
};

export type RemoveAreaResponse = {
  __typename?: 'RemoveAreaResponse';
  removedArea?: Maybe<RemovedArea>;
};

export type RemoveCardFromAccesslist = {
  accesslistId: Scalars['ID'];
  cardnumber: Scalars['String'];
};

export type RemoveCardFromAccesslistResponse = {
  __typename?: 'RemoveCardFromAccesslistResponse';
  accessCardId: Scalars['ID'];
  accesslist: Accesslist;
  cardnumber?: Maybe<Scalars['String']>;
};

export type RemoveCompanyAreas = {
  companyId: Scalars['ID'];
};

export type RemoveCompanyGateEvents = {
  companyId: Scalars['ID'];
};

export type RemoveDeviceGate = {
  id: Scalars['ID'];
};

export type RemoveDeviceGateResponse = {
  __typename?: 'RemoveDeviceGateResponse';
  deviceGate: DeviceGate;
};

export type RemoveGate = {
  areaId: Scalars['ID'];
  companyId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  gateId: Scalars['ID'];
};

export type RemoveGateEntity = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  force?: InputMaybe<Scalars['Boolean']>;
  gateId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['ID']>;
};

export type RemoveGateEntityResponse = {
  __typename?: 'RemoveGateEntityResponse';
  removedGateNode?: Maybe<RemovedGateNode>;
};

export type RemoveGateFromGateGroupResponse = {
  __typename?: 'RemoveGateFromGateGroupResponse';
  success: Scalars['Boolean'];
};

export type RemoveGateGroupResponse = {
  __typename?: 'RemoveGateGroupResponse';
  success: Scalars['Boolean'];
};

export type RemoveGateResponse = {
  __typename?: 'RemoveGateResponse';
  removedGate?: Maybe<RemovedGate>;
};

export type RemoveItemFromLocker = {
  itemId: Scalars['ID'];
};

export type RemoveItemFromLockerResponse = {
  __typename?: 'RemoveItemFromLockerResponse';
  item: Item;
};

export type RemoveLockerGroup = {
  lockerGroupId: Scalars['ID'];
};

export type RemoveLockerGroupResponse = {
  __typename?: 'RemoveLockerGroupResponse';
  lockerGroup?: Maybe<LockerGroup>;
};

export type RemoveLockersFromLockerGroup = {
  lockerGroupId: Scalars['ID'];
  lockerIds: Array<Scalars['ID']>;
};

export type RemoveLockersFromLockerGroupResponse = {
  __typename?: 'RemoveLockersFromLockerGroupResponse';
  lockerGroup?: Maybe<LockerGroup>;
};

export type RemoveLockersystemPermission = {
  lockersystemUserPermissionId: Scalars['ID'];
};

export type RemoveLockersystemPermissionResponse = {
  __typename?: 'RemoveLockersystemPermissionResponse';
  lockersystemUserPermissionId: Scalars['ID'];
};

export type RemovePasskeyInput = {
  passkeyId: Scalars['ID'];
};

export type RemovePasskeyResponse = {
  __typename?: 'RemovePasskeyResponse';
  success: Scalars['Boolean'];
};

export type RemoveTranslation = {
  key: Scalars['String'];
  language: Scalars['String'];
  lockersystemId?: InputMaybe<Scalars['ID']>;
};

export type RemoveTranslationResponse = {
  __typename?: 'RemoveTranslationResponse';
  translationId?: Maybe<Scalars['ID']>;
};

export type RemoveUser = {
  userId: Scalars['ID'];
};

export type RemoveUserDoorcontrolPermission = {
  doorcontrolDeviceNumber: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveUserDoorcontrolPermissionResponse = {
  __typename?: 'RemoveUserDoorcontrolPermissionResponse';
  userDoorcontrolPermissionId?: Maybe<Scalars['ID']>;
};

export type RemoveUserGroupLockersystemPermission = {
  userGroupLockersystemPermissionId: Scalars['ID'];
};

export type RemoveUserGroupLockersystemPermissionResponse = {
  __typename?: 'RemoveUserGroupLockersystemPermissionResponse';
  userGroupLockersystemPermissionId: Scalars['ID'];
};

export type RemoveUserLockerPermission = {
  lockerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveUserLockerPermissionResponse = {
  __typename?: 'RemoveUserLockerPermissionResponse';
  userLockerPermissionId?: Maybe<Scalars['ID']>;
};

export type RemoveUserResponse = {
  __typename?: 'RemoveUserResponse';
  userId?: Maybe<Scalars['ID']>;
};

export type RemovedArea = {
  __typename?: 'RemovedArea';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
};

export type RemovedGate = {
  __typename?: 'RemovedGate';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  gateId?: Maybe<Scalars['ID']>;
};

export type RemovedGateNode = {
  __typename?: 'RemovedGateNode';
  areaId?: Maybe<Scalars['ID']>;
  companyId?: Maybe<Scalars['ID']>;
  gateId?: Maybe<Scalars['ID']>;
  nodeId?: Maybe<Scalars['ID']>;
};

export type RentItem = {
  itemId: Scalars['ID'];
};

export type RentItemResponse = {
  __typename?: 'RentItemResponse';
  item: Item;
  renting: Renting;
};

export type Renting = {
  __typename?: 'Renting';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  code: Scalars['String'];
  codeUsedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  interruptedAt?: Maybe<Scalars['DateTime']>;
  interruptedBy?: Maybe<User>;
  item?: Maybe<Item>;
  locker: Locker;
  permitGiven?: Maybe<Scalars['Boolean']>;
  returnCode?: Maybe<Scalars['String']>;
  returnCodeUsedAt?: Maybe<Scalars['DateTime']>;
  returnItemBefore?: Maybe<Scalars['DateTime']>;
  state: RentingState;
  useCodeBefore?: Maybe<Scalars['DateTime']>;
  useReturnCodeBefore?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export enum RentingSortField {
  CreatedAt = 'CreatedAt',
  ReturnItemBefore = 'ReturnItemBefore'
}

export enum RentingState {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Finished = 'Finished',
  Interrupted = 'Interrupted',
  NeedsPermit = 'NeedsPermit',
  ReturnLate = 'ReturnLate',
  WaitsPickup = 'WaitsPickup',
  WaitsReturn = 'WaitsReturn'
}

export enum RentingStatisticsGroupBy {
  Day = 'Day',
  Month = 'Month',
  Year = 'Year'
}

export type RentingStatisticsRow = {
  __typename?: 'RentingStatisticsRow';
  item?: Maybe<Item>;
  rentingsCount?: Maybe<Scalars['Int']>;
};

export type RentingsConnection = {
  __typename?: 'RentingsConnection';
  rentings: Array<Renting>;
};

export type ReplaceLockerProgramBinary = {
  originalFileName: Scalars['String'];
  payload: Scalars['String'];
};

export type ReplaceLockerProgramBinaryResponse = {
  __typename?: 'ReplaceLockerProgramBinaryResponse';
  lockerProgram?: Maybe<LockerProgram>;
};

export type RequestLockerHistory = {
  deviceNumber: Scalars['ID'];
  endSeq: Scalars['Int'];
  lockerNumber: Scalars['Int'];
  startSeq: Scalars['Int'];
};

export type RequestLockerHistoryResponse = {
  __typename?: 'RequestLockerHistoryResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type RequestLockerStatus = {
  deviceNumber: Scalars['ID'];
  lockerNumbers: Array<Scalars['Int']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  cancelReason?: Maybe<CancelReason>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  doorcontrol?: Maybe<Doorcontrol>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  locker?: Maybe<Locker>;
  lockersystem?: Maybe<Lockersystem>;
  paid?: Maybe<Scalars['Boolean']>;
  pan?: Maybe<Scalars['String']>;
  postauthAmount?: Maybe<Scalars['Int']>;
  preauthAmount?: Maybe<Scalars['Int']>;
  receipt?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  token?: Maybe<Scalars['String']>;
};

export enum ReservationStatisticsGroupBy {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type ReservationStatisticsRow = {
  __typename?: 'ReservationStatisticsRow';
  bucketStart: Scalars['DateTime'];
  reservationCount: Scalars['Int'];
};

export enum ReservationStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Finished = 'Finished',
  Pending = 'Pending'
}

export type ReservationsChange = {
  __typename?: 'ReservationsChange';
  reservations?: Maybe<Array<Reservation>>;
};

export type ReservationsResponse = {
  __typename?: 'ReservationsResponse';
  activeReservationsCount?: Maybe<Scalars['Int']>;
  cancelledReservationsCount?: Maybe<Scalars['Int']>;
  finishedReservationsCount?: Maybe<Scalars['Int']>;
  paidAmount?: Maybe<Scalars['Int']>;
  reservations?: Maybe<Array<Reservation>>;
  totalReservationsCount?: Maybe<Scalars['Int']>;
  uniqueReservationsCount?: Maybe<Scalars['Int']>;
};

export type ReservationsSearchOptions = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  pan?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<ReservationStatus>;
  token?: InputMaybe<Scalars['String']>;
};

export type ResetGateCounters = {
  areaId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  gateId?: InputMaybe<Scalars['ID']>;
  nodeId?: InputMaybe<Scalars['ID']>;
};

export type ReturnRentedItem = {
  rentingId: Scalars['ID'];
};

export type ReturnRentedItemResponse = {
  __typename?: 'ReturnRentedItemResponse';
  code?: Maybe<Scalars['String']>;
  itemAlreadyRenturned?: Maybe<Scalars['Boolean']>;
  renting?: Maybe<Renting>;
  success: Scalars['Boolean'];
};

export type RevokeUserSession = {
  userSessionId: Scalars['ID'];
};

export type RevokeUserSessionResponse = {
  __typename?: 'RevokeUserSessionResponse';
  success: Scalars['Boolean'];
};

export type SaveTestReportInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  doorcontrolDeviceNumber: Scalars['String'];
  metadata?: InputMaybe<TestReportMetadataInput>;
  panels: Array<TestReportPanelInput>;
  reportId?: InputMaybe<Scalars['ID']>;
  reportType: TestReportType;
};

export type SaveTestReportResponse = {
  __typename?: 'SaveTestReportResponse';
  testReport: TestReport;
};

export type ScheduledLockerProgramUpdate = {
  __typename?: 'ScheduledLockerProgramUpdate';
  bitrate: Scalars['Int'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId: Scalars['ID'];
  deviceNumber: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lockerProgram?: Maybe<LockerProgram>;
  lockerProgramId: Scalars['ID'];
  scheduledAt: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: ScheduledLockerProgramUpdateStatus;
};

export enum ScheduledLockerProgramUpdateStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Running = 'Running'
}

export type SearchFeedbacksConnection = {
  __typename?: 'SearchFeedbacksConnection';
  feedbacks: Array<Feedback>;
  totalCount: Scalars['Int'];
};

export type SearchItemGroupsOptions = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
  parentItemGroupId?: InputMaybe<Scalars['ID']>;
  searchWord?: InputMaybe<Scalars['String']>;
};

export type SearchItemsOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyShowRentable?: InputMaybe<Scalars['Boolean']>;
  searchWord?: InputMaybe<Scalars['String']>;
};

export type SearchLockersystemsConnection = {
  __typename?: 'SearchLockersystemsConnection';
  lockersystems: Array<Lockersystem>;
  totalCount: Scalars['Int'];
};

export type SeitaState = {
  __typename?: 'SeitaState';
  connected?: Maybe<Scalars['Boolean']>;
};

export type SelectLockersystemResponse = {
  __typename?: 'SelectLockersystemResponse';
  success?: Maybe<Scalars['Boolean']>;
  viewer?: Maybe<Viewer>;
};

export type SendCardKeys = {
  cardKeysId?: InputMaybe<Scalars['ID']>;
  deviceNumber: Scalars['String'];
};

export type SendCardKeysResponse = {
  __typename?: 'SendCardKeysResponse';
  status?: Maybe<CommandStatus>;
};

export type SendConfigToDoorcontrol = {
  deviceNumber: Scalars['String'];
};

export type SendConfigToDoorcontrolResponse = {
  __typename?: 'SendConfigToDoorcontrolResponse';
  status?: Maybe<CommandStatus>;
};

export type SendDelivery = {
  deliveryId: Scalars['ID'];
  email: Scalars['String'];
  useCodeBefore?: InputMaybe<Scalars['DateTime']>;
};

export type SendDeliveryResponse = {
  __typename?: 'SendDeliveryResponse';
  delivery?: Maybe<Delivery>;
};

export type SendDoormapToLockerNodes = {
  deviceNumber: Scalars['ID'];
  targets: Array<DoormapTarget>;
};

export type SendDoormapToLockerNodesResponse = {
  __typename?: 'SendDoormapToLockerNodesResponse';
  status: CommandStatus;
};

export type SendDoormapToLockers = {
  deviceNumber: Scalars['ID'];
  lockerNumbers?: InputMaybe<Array<Scalars['Int']>>;
};

export type SendDoormapToLockersResponse = {
  __typename?: 'SendDoormapToLockersResponse';
  status?: Maybe<CommandStatus>;
};

export type SendEmailInput = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  includeReplyTo?: InputMaybe<Scalars['Boolean']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
  text: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  userRentingInProgress?: InputMaybe<Scalars['Boolean']>;
};

export type SendEmailResponse = {
  __typename?: 'SendEmailResponse';
  emailsSent: Scalars['Int'];
};

export type SendFeedback = {
  deliveryId?: InputMaybe<Scalars['ID']>;
  eventTime?: InputMaybe<Scalars['DateTime']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  rentingId?: InputMaybe<Scalars['ID']>;
  type: FeedbackType;
  userId?: InputMaybe<Scalars['ID']>;
};

export type SendFeedbackResponse = {
  __typename?: 'SendFeedbackResponse';
  feedback?: Maybe<Feedback>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SendLockerUpdateEndFrame = {
  deviceNumber: Scalars['String'];
};

export type SendLockerUpdateEndFrameResponse = {
  __typename?: 'SendLockerUpdateEndFrameResponse';
  status?: Maybe<CommandStatus>;
};

export type SendLockersystemMasterWhitelistInput = {
  lockersystemId: Scalars['ID'];
};

export type SendLockersystemMasterWhitelistResponse = {
  __typename?: 'SendLockersystemMasterWhitelistResponse';
  deliveredConnections: Scalars['Int'];
  status: CommandStatus;
  version: Scalars['Int'];
};

export type SendMasterPincode = {
  deviceNumber: Scalars['String'];
  pincode: Scalars['String'];
};

export type SendRentingLateReminderInput = {
  language?: InputMaybe<Scalars['String']>;
  rentingId: Scalars['ID'];
};

export type SendRentingLateReminderResponse = {
  __typename?: 'SendRentingLateReminderResponse';
  success: Scalars['Boolean'];
};

export type SendSeitaCmd = {
  abort?: InputMaybe<Scalars['Boolean']>;
  deviceNumber: Scalars['String'];
};

export type SendSeitaCmdResponse = {
  __typename?: 'SendSeitaCmdResponse';
  result?: Maybe<Scalars['String']>;
  status?: Maybe<CommandStatus>;
};

export type SendSeitaLogs = {
  deviceNumber: Scalars['String'];
};

export type SendSeitaLogsResponse = {
  __typename?: 'SendSeitaLogsResponse';
  result?: Maybe<Scalars['String']>;
  status?: Maybe<CommandStatus>;
};

export type SendTestTranslationEmailInput = {
  key: Scalars['String'];
  language: Scalars['String'];
  lockersystemId: Scalars['ID'];
};

export type SendTestTranslationEmailResponse = {
  __typename?: 'SendTestTranslationEmailResponse';
  success: Scalars['Boolean'];
};

export type ServerSettings = {
  __typename?: 'ServerSettings';
  criticalWebhooksDisabled: Scalars['Boolean'];
  googleWalletConfiguration: GoogleWalletConfiguration;
  updatedAt: Scalars['DateTime'];
};

export type SetAudioMode = {
  deviceNumber: Scalars['String'];
  doors?: InputMaybe<Array<Scalars['Int']>>;
  duration?: InputMaybe<Scalars['Int']>;
  mode: AudioModeCmd;
};

export type SetAudioModeResponse = {
  __typename?: 'SetAudioModeResponse';
  status?: Maybe<CommandStatus>;
};

export type SetDoorAccess = {
  allowed: Scalars['Boolean'];
  deviceNumber: Scalars['ID'];
  master?: InputMaybe<Scalars['Boolean']>;
};

export type SetDoorAccessResponse = {
  __typename?: 'SetDoorAccessResponse';
  status?: Maybe<CommandStatus>;
};

export type SetHallTestMode = {
  deviceNumber: Scalars['String'];
  doors?: InputMaybe<Array<Scalars['Int']>>;
  enabled: Scalars['Boolean'];
};

export type SetHallTestModeResponse = {
  __typename?: 'SetHallTestModeResponse';
  status?: Maybe<CommandStatus>;
};

export type SetLockersystemMasterWhitelistInput = {
  cards: Array<Scalars['String']>;
  lockersystemId: Scalars['ID'];
};

export type SetLockersystemMasterWhitelistResponse = {
  __typename?: 'SetLockersystemMasterWhitelistResponse';
  masterWhitelist: MasterWhitelist;
};

export type SetMasterWhitelist = {
  cards: Array<Scalars['String']>;
  deviceNumber: Scalars['String'];
  node: Scalars['Int'];
  segment: Scalars['Int'];
};

export type SetMasterWhitelistResponse = {
  __typename?: 'SetMasterWhitelistResponse';
  status?: Maybe<CommandStatus>;
};

export type SetOutOfOrderMode = {
  deviceNumber: Scalars['String'];
  doors?: InputMaybe<Array<Scalars['Int']>>;
  mode: OutOfOrderModeCmd;
};

export type SetOutOfOrderModeResponse = {
  __typename?: 'SetOutOfOrderModeResponse';
  status?: Maybe<CommandStatus>;
};

export type SetPanelId = {
  deviceNumber: Scalars['String'];
  node: Scalars['Int'];
  panelId?: InputMaybe<Scalars['Int']>;
};

export type SetPanelIdResponse = {
  __typename?: 'SetPanelIdResponse';
  status?: Maybe<CommandStatus>;
};

export type SetupAccessGroup = {
  allowLockAll?: InputMaybe<Scalars['Boolean']>;
  canPreventOpening?: InputMaybe<Scalars['Boolean']>;
  maxLockedCount?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type SetupAccessGroupAccess = {
  access: Scalars['Boolean'];
  accessGroup: Scalars['String'];
  master: Scalars['Boolean'];
  maxLockedCount?: InputMaybe<Scalars['Int']>;
};

export type SetupAccesslist = {
  accessGroupAccess?: InputMaybe<Array<SetupAccessGroupAccess>>;
  cards?: InputMaybe<Array<Scalars['String']>>;
  clearAccesslistChanges?: InputMaybe<Scalars['Boolean']>;
  clearCards?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SetupDeviceGate = {
  areaId: Scalars['ID'];
  companyId: Scalars['ID'];
  deviceNumber: Scalars['String'];
  gateId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type SetupDoorcontrol = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  cluster: Scalars['String'];
  deviceNumber: Scalars['String'];
};

export type SetupFileMessage = {
  __typename?: 'SetupFileMessage';
  metadata?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SetupItem = {
  clearRentings?: InputMaybe<Scalars['Boolean']>;
  locker: Scalars['Int'];
  name: Scalars['String'];
  needsPermit?: InputMaybe<Scalars['Boolean']>;
  rentable?: InputMaybe<Scalars['Boolean']>;
};

export type SetupLainaamoTerminals = {
  deviceNumber: Scalars['String'];
};

export type SetupLockerGroup = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  lainaamo?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SetupLockerNode = {
  access?: InputMaybe<Scalars['Boolean']>;
  cluster: Scalars['String'];
  demo?: InputMaybe<Scalars['Boolean']>;
  desfire?: InputMaybe<Scalars['Boolean']>;
  hslDesfire?: InputMaybe<Scalars['Boolean']>;
  keepLock?: InputMaybe<Scalars['Boolean']>;
  keyCheck?: InputMaybe<Scalars['Boolean']>;
  leftDownAccessGroup?: InputMaybe<Scalars['String']>;
  leftDownDoorNr?: InputMaybe<Scalars['Int']>;
  leftDownLockerGroup?: InputMaybe<Scalars['String']>;
  leftDownLockerSeq?: InputMaybe<Scalars['Int']>;
  leftOpen?: InputMaybe<Scalars['Boolean']>;
  leftUpAccessGroup?: InputMaybe<Scalars['String']>;
  leftUpDoorNr?: InputMaybe<Scalars['Int']>;
  leftUpLockerGroup?: InputMaybe<Scalars['String']>;
  leftUpLockerSeq?: InputMaybe<Scalars['Int']>;
  mifare?: InputMaybe<Scalars['Boolean']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  multiuse?: InputMaybe<Scalars['Boolean']>;
  node: Scalars['Int'];
  personal?: InputMaybe<Scalars['Boolean']>;
  rightDownAccessGroup?: InputMaybe<Scalars['String']>;
  rightDownDoorNr?: InputMaybe<Scalars['Int']>;
  rightDownLockerGroup?: InputMaybe<Scalars['String']>;
  rightDownLockerSeq?: InputMaybe<Scalars['Int']>;
  rightOpen?: InputMaybe<Scalars['Boolean']>;
  rightUpAccessGroup?: InputMaybe<Scalars['String']>;
  rightUpDoorNr?: InputMaybe<Scalars['Int']>;
  rightUpLockerGroup?: InputMaybe<Scalars['String']>;
  rightUpLockerSeq?: InputMaybe<Scalars['Int']>;
  segment: Scalars['Int'];
  silent?: InputMaybe<Scalars['Boolean']>;
  ultralight?: InputMaybe<Scalars['Boolean']>;
  verticalDoubleLock?: InputMaybe<Scalars['Boolean']>;
};

export type SetupLockersystem = {
  accessGroups?: InputMaybe<Array<SetupAccessGroup>>;
  accesslists?: InputMaybe<Array<SetupAccesslist>>;
  alertsEnabled?: InputMaybe<Scalars['Boolean']>;
  breakinAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  clearAccessCards?: InputMaybe<Scalars['Boolean']>;
  clearHistory?: InputMaybe<Scalars['Boolean']>;
  clearState?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  dashboardLayoutId?: InputMaybe<DashboardLayoutType>;
  deliveryAllowed?: InputMaybe<Scalars['Boolean']>;
  deliveryNonRegistered?: InputMaybe<Scalars['Boolean']>;
  deliveryWithIdentityCode?: InputMaybe<Scalars['Boolean']>;
  deviceGates?: InputMaybe<Array<SetupDeviceGate>>;
  doorcontrols?: InputMaybe<Array<SetupDoorcontrol>>;
  emailPermissionDomains?: InputMaybe<Array<Scalars['String']>>;
  items?: InputMaybe<Array<SetupItem>>;
  lainaamoTerminals?: InputMaybe<Array<SetupLainaamoTerminals>>;
  lockerGroups?: InputMaybe<Array<SetupLockerGroup>>;
  lockerNodes?: InputMaybe<Array<SetupLockerNode>>;
  name: Scalars['String'];
  publicDashboardEnabled?: InputMaybe<Scalars['Boolean']>;
  removeUserByEmail?: InputMaybe<Array<Scalars['String']>>;
  rentingAllowed?: InputMaybe<Scalars['Boolean']>;
  rentingNonRegistered?: InputMaybe<Scalars['Boolean']>;
  showWhoBorrows?: InputMaybe<Scalars['Boolean']>;
  sympathyAlarmCount?: InputMaybe<Scalars['Int']>;
  userPermissions?: InputMaybe<Array<SetupUserPermission>>;
  users?: InputMaybe<Array<SetupUser>>;
};

export type SetupLockersystemResponse = {
  __typename?: 'SetupLockersystemResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type SetupUserPermission = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lockersystemAdmin?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

export enum SigninType {
  Google = 'Google',
  HakaSaml = 'HakaSaml',
  Internal = 'Internal',
  OuluUniSaml = 'OuluUniSaml',
  Portal = 'Portal'
}

export type StopLockerUpdate = {
  deviceNumber: Scalars['String'];
};

export type StopLockerUpdateResponse = {
  __typename?: 'StopLockerUpdateResponse';
  status?: Maybe<CommandStatus>;
};

export type Subscription = {
  __typename?: 'Subscription';
  breakInAlarm: BreakInAlarm;
  canbusChange?: Maybe<CanbusChange>;
  candump: CanbusMessage;
  companyGateStateChanges: CompanyGateState;
  companyLockersystemStateChanges?: Maybe<CompanyLockersystemChange>;
  doorcontrolChange?: Maybe<Doorcontrol>;
  doorcontrolDoormapLockers: Array<Locker>;
  doorcontrolLockers: Array<DoorcontrolLocker>;
  doorcontrolLogStream: DoorcontrolLogMessage;
  doorcontrolStateChange?: Maybe<DoorcontrolStateChange>;
  doorcontrolsChange?: Maybe<Doorcontrol>;
  jobLogStream: JobLogEntry;
  lockerGroupLockers: Array<Locker>;
  lockersystemLockerGroups: Array<LockerGroup>;
  lockersystemLockers: Array<Locker>;
  newDoorcontrolEvent: Array<DoorcontrolEvent>;
  newDoorcontrolMsg: Array<DoorcontrolMessage>;
  newLockerHistoryEvent?: Maybe<LockerHistoryEvent>;
  newValidation: Validation;
  nodeConnectionAdded: NodeConnection;
  nodeConnectionRemoved: Scalars['ID'];
  reservationsChange?: Maybe<ReservationsChange>;
};


export type SubscriptionBreakInAlarmArgs = {
  companyId: Scalars['ID'];
};


export type SubscriptionCanbusChangeArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionCandumpArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionCompanyGateStateChangesArgs = {
  companyId: Scalars['ID'];
};


export type SubscriptionCompanyLockersystemStateChangesArgs = {
  companyId: Scalars['ID'];
};


export type SubscriptionDoorcontrolChangeArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionDoorcontrolDoormapLockersArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionDoorcontrolLockersArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionDoorcontrolLogStreamArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionDoorcontrolStateChangeArgs = {
  deviceNumber: Scalars['ID'];
};


export type SubscriptionJobLogStreamArgs = {
  jobId: Scalars['ID'];
};


export type SubscriptionLockerGroupLockersArgs = {
  lockerGroupId: Scalars['ID'];
};


export type SubscriptionLockersystemLockerGroupsArgs = {
  lainaamo?: InputMaybe<Scalars['Boolean']>;
  lockersystemId: Scalars['ID'];
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionLockersystemLockersArgs = {
  lockersystemId: Scalars['ID'];
};


export type SubscriptionNewDoorcontrolEventArgs = {
  deviceNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionNewDoorcontrolMsgArgs = {
  deviceNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionNewLockerHistoryEventArgs = {
  deviceNumber?: InputMaybe<Scalars['String']>;
};


export type SubscriptionNewValidationArgs = {
  companyId: Scalars['ID'];
};


export type SubscriptionReservationsChangeArgs = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
};

export type TestReport = {
  __typename?: 'TestReport';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  doorcontrol?: Maybe<Doorcontrol>;
  id: Scalars['ID'];
  interruptedAt?: Maybe<Scalars['DateTime']>;
  metadata: TestReportMetadata;
  panels: Array<Panel>;
  reportType: TestReportType;
};

export type TestReportBoard = {
  __typename?: 'TestReportBoard';
  boardNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fluorescent?: Maybe<Scalars['Boolean']>;
  halBoardNumber?: Maybe<Scalars['String']>;
  halFluorescent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  serialNumber?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type TestReportBoardInput = {
  boardNumber?: InputMaybe<Scalars['String']>;
  fluorescent?: InputMaybe<Scalars['Boolean']>;
  halBoardNumber?: InputMaybe<Scalars['String']>;
  halFluorescent?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['Int']>;
};

export type TestReportDoorTestResult = {
  __typename?: 'TestReportDoorTestResult';
  doorNumber: Scalars['Int'];
  nodeNumber?: Maybe<Scalars['Int']>;
  tested: Scalars['Boolean'];
};

export type TestReportDoorTestResultInput = {
  doorNumber: Scalars['Int'];
  nodeNumber?: InputMaybe<Scalars['Int']>;
  tested: Scalars['Boolean'];
};

export type TestReportMetadata = {
  __typename?: 'TestReportMetadata';
  catCablesSeated?: Maybe<Scalars['Boolean']>;
  doorTestResults: Array<TestReportDoorTestResult>;
  installerVariant?: Maybe<Scalars['String']>;
  interruptionReason?: Maybe<Scalars['String']>;
  lockSocketLatchCorrect?: Maybe<Scalars['Boolean']>;
  lockSocketsTight?: Maybe<Scalars['Boolean']>;
  lockerVisualOk?: Maybe<Scalars['Boolean']>;
  motorCablesSeated?: Maybe<Scalars['Boolean']>;
  panelIdentifier?: Maybe<Scalars['Int']>;
  panelType?: Maybe<Scalars['Int']>;
  pemScrewsChecked?: Maybe<Scalars['Boolean']>;
  visualTestNotes?: Maybe<Scalars['String']>;
};

export type TestReportMetadataInput = {
  catCablesSeated?: InputMaybe<Scalars['Boolean']>;
  doorTestResults?: InputMaybe<Array<TestReportDoorTestResultInput>>;
  installerVariant?: InputMaybe<Scalars['String']>;
  interruptionReason?: InputMaybe<Scalars['String']>;
  lockSocketLatchCorrect?: InputMaybe<Scalars['Boolean']>;
  lockSocketsTight?: InputMaybe<Scalars['Boolean']>;
  lockerVisualOk?: InputMaybe<Scalars['Boolean']>;
  motorCablesSeated?: InputMaybe<Scalars['Boolean']>;
  panelIdentifier?: InputMaybe<Scalars['Int']>;
  panelType?: InputMaybe<Scalars['Int']>;
  pemScrewsChecked?: InputMaybe<Scalars['Boolean']>;
  visualTestNotes?: InputMaybe<Scalars['String']>;
};

export type TestReportPanelInput = {
  boards?: InputMaybe<Array<TestReportBoardInput>>;
  panelId?: InputMaybe<Scalars['Int']>;
};

export enum TestReportType {
  LockerTest = 'LockerTest',
  PakettipisteLockerConfiguration = 'PakettipisteLockerConfiguration',
  PanelTest = 'PanelTest'
}

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Int']>;
  cardHash?: Maybe<Scalars['String']>;
  doorcontrol?: Maybe<Doorcontrol>;
  id?: Maybe<Scalars['ID']>;
  lockersystem?: Maybe<Lockersystem>;
  outcome?: Maybe<Outcome>;
  pan?: Maybe<Scalars['String']>;
  receipt?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  transactionType?: Maybe<TransactionType>;
};

export enum TransactionType {
  Cancellation = 'Cancellation',
  Postauth = 'Postauth',
  Preauth = 'Preauth',
  Readcard = 'Readcard',
  Unknown = 'Unknown'
}

export type TransactionsSearchOptions = {
  cardHash?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Outcome>;
  pan?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  transactionType?: InputMaybe<TransactionType>;
};

export type TransferRenting = {
  rentingId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type TransferRentingResponse = {
  __typename?: 'TransferRentingResponse';
  renting: Renting;
};

export type Translation = {
  __typename?: 'Translation';
  id: Scalars['ID'];
  key: Scalars['String'];
  language: Scalars['String'];
  lockersystemId?: Maybe<Scalars['ID']>;
  translation: Scalars['String'];
};

export type TranslationItem = {
  __typename?: 'TranslationItem';
  default: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  language: Scalars['String'];
  translation?: Maybe<Scalars['String']>;
  variables: Array<Scalars['String']>;
};

export type UnblockDoorcontrol = {
  deviceNumber: Scalars['ID'];
};

export type UnblockDoorcontrolResponse = {
  __typename?: 'UnblockDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type UpdateAccessGroup = {
  accessGroupId: Scalars['ID'];
  allowLockAll?: InputMaybe<Scalars['Boolean']>;
  canPreventOpening?: InputMaybe<Scalars['Boolean']>;
  maxLockedPerCard?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  requireLockerPerm?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAccessGroupAccess = {
  accessGroupAccessId: Scalars['ID'];
  master?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAccessGroupAccessResponse = {
  __typename?: 'UpdateAccessGroupAccessResponse';
  accessGroupAccess?: Maybe<AccessGroupAccess>;
};

export type UpdateAccessGroupResponse = {
  __typename?: 'UpdateAccessGroupResponse';
  accessGroup: AccessGroup;
};

export type UpdateAccesslist = {
  accesslistId: Scalars['ID'];
  hidden?: InputMaybe<Scalars['Boolean']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAccesslistResponse = {
  __typename?: 'UpdateAccesslistResponse';
  accesslist: Accesslist;
};

export type UpdateCostTable = {
  entries: Array<CostTableEntryInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCostTableResponse = {
  __typename?: 'UpdateCostTableResponse';
  costTable?: Maybe<CostTable>;
};

export type UpdateDelivery = {
  deliveryId: Scalars['ID'];
  pickedUpAt?: InputMaybe<Scalars['DateTime']>;
  pickupBefore?: InputMaybe<Scalars['DateTime']>;
  pickupUserId?: InputMaybe<Scalars['ID']>;
  sendPickedUpEmail?: InputMaybe<Scalars['Boolean']>;
  useCodeBefore?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateDeliveryResponse = {
  __typename?: 'UpdateDeliveryResponse';
  delivery?: Maybe<Delivery>;
};

export type UpdateDeviceGate = {
  areaId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  gateId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  nodeId?: InputMaybe<Scalars['ID']>;
};

export type UpdateDeviceGateResponse = {
  __typename?: 'UpdateDeviceGateResponse';
  deviceGate: DeviceGate;
};

export type UpdateDoorcontrol = {
  adminMenuPassword?: InputMaybe<Scalars['String']>;
  adminMenuVisible?: InputMaybe<Scalars['Boolean']>;
  barcodeEnabled?: InputMaybe<Scalars['Boolean']>;
  barcodePort?: InputMaybe<Scalars['String']>;
  canbridgeUsed?: InputMaybe<Scalars['Boolean']>;
  canbusEnabled?: InputMaybe<Scalars['Boolean']>;
  cardKeysId?: InputMaybe<Scalars['ID']>;
  costGapType?: InputMaybe<CostGapType>;
  costGapValue?: InputMaybe<Scalars['Int']>;
  costTableId?: InputMaybe<Scalars['ID']>;
  debugMode?: InputMaybe<Scalars['Boolean']>;
  deviceNumber: Scalars['ID'];
  guiMode?: InputMaybe<GuiMode>;
  hide?: InputMaybe<Scalars['Boolean']>;
  latestReservationHour?: InputMaybe<Scalars['Int']>;
  latestReservationMinute?: InputMaybe<Scalars['Int']>;
  localApiEnabled?: InputMaybe<LocalApiEnabled>;
  loglevel?: InputMaybe<Loglevel>;
  maxReservationTime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nfcAction?: InputMaybe<NfcAction>;
  offlineAccesslistEnabled?: InputMaybe<Scalars['Boolean']>;
  openDoorGPIOPin?: InputMaybe<Scalars['Int']>;
  openDoorPulseDuration?: InputMaybe<Scalars['Int']>;
  outOfOrder?: InputMaybe<Scalars['Boolean']>;
  qrAction?: InputMaybe<QrAction>;
  rateLimit?: InputMaybe<Scalars['Int']>;
  remoteOpenEnabled?: InputMaybe<Scalars['Boolean']>;
  reportErrors?: InputMaybe<Scalars['Boolean']>;
  reportNodeOffline?: InputMaybe<Scalars['Boolean']>;
  reportOfflines?: InputMaybe<Scalars['Boolean']>;
  seitaEnabled?: InputMaybe<Scalars['Boolean']>;
  seitaGpioActive?: InputMaybe<Scalars['Boolean']>;
  seitaGpioPin?: InputMaybe<Scalars['Int']>;
  seitaurl?: InputMaybe<Scalars['String']>;
};

export type UpdateDoorcontrolResponse = {
  __typename?: 'UpdateDoorcontrolResponse';
  doorcontrol?: Maybe<Doorcontrol>;
};

export type UpdateDoorcontrolSelf = {
  deviceNumber: Scalars['ID'];
};

export type UpdateDoorcontrolSelfResponse = {
  __typename?: 'UpdateDoorcontrolSelfResponse';
  doorcontrol?: Maybe<Doorcontrol>;
  status: CommandStatus;
};

export type UpdateDoormap = {
  lockersystemId: Scalars['ID'];
  rows: Array<DoormapRow>;
};

export type UpdateDoormapResponse = {
  __typename?: 'UpdateDoormapResponse';
  lockersystem: Lockersystem;
  messages: Array<SetupFileMessage>;
};

export type UpdateGateNode = {
  allowCloseSales?: InputMaybe<Scalars['Boolean']>;
  allowOpenSales?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  gateId?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['String']>;
  useForCounters?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateGateNodeResponse = {
  __typename?: 'UpdateGateNodeResponse';
  gateNode?: Maybe<GateNode>;
};

export type UpdateItem = {
  description?: InputMaybe<Scalars['String']>;
  emailAdminWhenReturned?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['Upload']>;
  itemGroupId?: InputMaybe<Scalars['ID']>;
  itemId: Scalars['ID'];
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId?: InputMaybe<Scalars['ID']>;
  lockersystemId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  needsPermit?: InputMaybe<Scalars['Boolean']>;
  rentable?: InputMaybe<Scalars['Boolean']>;
  rentingTime?: InputMaybe<Scalars['Int']>;
};

export type UpdateItemGroup = {
  borrowingRightsUserGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  itemGroupId: Scalars['ID'];
  maxRentingsPerUser?: InputMaybe<Scalars['Int']>;
  maxRentingsPerUserEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateItemGroupResponse = {
  __typename?: 'UpdateItemGroupResponse';
  itemGroup?: Maybe<ItemGroup>;
};

export type UpdateItemResponse = {
  __typename?: 'UpdateItemResponse';
  item?: Maybe<Item>;
};

export type UpdateLocker = {
  accessGroupId?: InputMaybe<Scalars['ID']>;
  depth?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  lockerId: Scalars['ID'];
  maintenanceMode?: InputMaybe<Scalars['Boolean']>;
  terminal?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UpdateLockerBoardStatusInput = {
  boardId: Scalars['ID'];
  status: LockerBoardStatus;
};

export type UpdateLockerBoardStatusResponse = {
  __typename?: 'UpdateLockerBoardStatusResponse';
  board: LockerBoard;
};

export type UpdateLockerGroup = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  lainaamo?: InputMaybe<Scalars['Boolean']>;
  lockerGroupId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  parentLockerGroupId?: InputMaybe<Scalars['ID']>;
};

export type UpdateLockerGroupResponse = {
  __typename?: 'UpdateLockerGroupResponse';
  lockerGroup?: Maybe<LockerGroup>;
  lockersystem?: Maybe<Lockersystem>;
};

export type UpdateLockerNode = {
  leftDownDoorVisible?: InputMaybe<Scalars['Boolean']>;
  leftDownLockerNumber?: InputMaybe<Scalars['Int']>;
  leftUpDoorVisible?: InputMaybe<Scalars['Boolean']>;
  leftUpLockerNumber?: InputMaybe<Scalars['Int']>;
  lockerNodeId: Scalars['ID'];
  lockerUnitId?: InputMaybe<Scalars['ID']>;
  rightDownDoorVisible?: InputMaybe<Scalars['Boolean']>;
  rightDownLockerNumber?: InputMaybe<Scalars['Int']>;
  rightUpDoorVisible?: InputMaybe<Scalars['Boolean']>;
  rightUpLockerNumber?: InputMaybe<Scalars['Int']>;
};

export type UpdateLockerProgram = {
  bitrate?: InputMaybe<Scalars['Int']>;
  deviceNumber: Scalars['String'];
  programId: Scalars['ID'];
  tested?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateLockerProgramLabel = {
  description?: InputMaybe<Scalars['String']>;
  lockerProgramId?: InputMaybe<Scalars['ID']>;
  lockerProgramLabelId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLockerProgramLabelResponse = {
  __typename?: 'UpdateLockerProgramLabelResponse';
  lockerProgramLabel?: Maybe<LockerProgramLabel>;
};

export type UpdateLockerProgramMetadata = {
  description?: InputMaybe<Scalars['String']>;
  lockerProgramId: Scalars['ID'];
  tested?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateLockerProgramMetadataResponse = {
  __typename?: 'UpdateLockerProgramMetadataResponse';
  lockerProgram?: Maybe<LockerProgram>;
};

export type UpdateLockerProgramResponse = {
  __typename?: 'UpdateLockerProgramResponse';
  status?: Maybe<CommandStatus>;
};

export type UpdateLockerResponse = {
  __typename?: 'UpdateLockerResponse';
  locker: Locker;
};

export type UpdateLockerStates = {
  lockerStates: Array<InputMaybe<LockerState>>;
  lockersystemId: Scalars['ID'];
};

export type UpdateLockerStatesResponse = {
  __typename?: 'UpdateLockerStatesResponse';
  lockers: Array<Maybe<Locker>>;
};

export type UpdateLockerUnit = {
  lockerGroupId: Scalars['ID'];
  lockerNodeIds: Array<Scalars['ID']>;
  lockerUnitId: Scalars['ID'];
};

export type UpdateLockers = {
  lockers: Array<InputMaybe<UpdateLocker>>;
};

export type UpdateLockersResponse = {
  __typename?: 'UpdateLockersResponse';
  lockers: Array<Maybe<Locker>>;
};

export type UpdateLockersystem = {
  adminEmailUserGroupId?: InputMaybe<Scalars['ID']>;
  alertsEnabled?: InputMaybe<Scalars['Boolean']>;
  anonymousQrReservationAllowed?: InputMaybe<Scalars['Boolean']>;
  automaticAdminPasswordChange?: InputMaybe<Scalars['Boolean']>;
  breakinAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  cabinetType?: InputMaybe<LockersystemCabinetType>;
  cardKeysId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<Scalars['ID']>>;
  dashboardLayoutId?: InputMaybe<DashboardLayoutType>;
  deliveryAllowed?: InputMaybe<Scalars['Boolean']>;
  deliveryNonRegistered?: InputMaybe<Scalars['Boolean']>;
  deliveryWithIdentityCode?: InputMaybe<Scalars['Boolean']>;
  emailPermissionDomains?: InputMaybe<Array<Scalars['String']>>;
  googleUsersAllowed?: InputMaybe<Scalars['Boolean']>;
  installationDate?: InputMaybe<Scalars['DateTime']>;
  lockersystemId: Scalars['ID'];
  maintenanceMode?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  newLockerProgramLabelId?: InputMaybe<Scalars['ID']>;
  oldLockerProgramLabelId?: InputMaybe<Scalars['ID']>;
  openSystem?: InputMaybe<Scalars['Boolean']>;
  ouluUniUsersAllowed?: InputMaybe<Scalars['Boolean']>;
  passivated?: InputMaybe<Scalars['Boolean']>;
  publicDashboardEnabled?: InputMaybe<Scalars['Boolean']>;
  rentingAllowed?: InputMaybe<Scalars['Boolean']>;
  rentingLateNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  rentingNonRegistered?: InputMaybe<Scalars['Boolean']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  showWhoBorrows?: InputMaybe<Scalars['Boolean']>;
  sympathyAlarmCount?: InputMaybe<Scalars['Int']>;
  urlId?: InputMaybe<Scalars['ID']>;
  userPermMods?: InputMaybe<Array<UserLockersystemPermMod>>;
};

export type UpdateLockersystemAccessGroups = {
  lockersystemId: Scalars['ID'];
  newAccessGroups: Array<NewAccessGroup>;
  removeAccessGroups: Array<RemoveAccessGroup>;
  updateAccessGroups: Array<UpdateAccessGroup>;
  updateLocker: Array<UpdateLocker>;
};

export type UpdateLockersystemAccessGroupsResponse = {
  __typename?: 'UpdateLockersystemAccessGroupsResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type UpdateLockersystemLockerGroups = {
  lockerUnitNodeId: Array<Scalars['ID']>;
  lockersystemId: Scalars['ID'];
  newLockerGroups: Array<CreateLockerGroup>;
  newLockerUnits: Array<UpdateLockerUnit>;
  removedLockerGroupIds: Array<Scalars['ID']>;
  removedLockerUnits: Array<Scalars['ID']>;
  updateLockerNodes: Array<UpdateLockerNode>;
  updateLockers: Array<UpdateLocker>;
  updatedLockerGroups: Array<UpdateLockerGroup>;
};

export type UpdateLockersystemLockerGroupsResponse = {
  __typename?: 'UpdateLockersystemLockerGroupsResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type UpdateLockersystemPermission = {
  accessDenied?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  lockersystemPermissionId: Scalars['ID'];
};

export type UpdateLockersystemPermissionResponse = {
  __typename?: 'UpdateLockersystemPermissionResponse';
  lockersystemUserPermission?: Maybe<LockersystemUserPermission>;
};

export type UpdateLockersystemResponse = {
  __typename?: 'UpdateLockersystemResponse';
  lockersystem?: Maybe<Lockersystem>;
};

export type UpdateMasterCardNameInput = {
  masterCardId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateRenting = {
  rentingId: Scalars['ID'];
  returnItemBefore?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateRentingResponse = {
  __typename?: 'UpdateRentingResponse';
  renting: Renting;
};

export type UpdateServerSettingsInput = {
  criticalWebhooksDisabled: Scalars['Boolean'];
};

export type UpdateServerSettingsResponse = {
  __typename?: 'UpdateServerSettingsResponse';
  serverSettings: ServerSettings;
};

export type UpdateTranslation = {
  key: Scalars['String'];
  language: Scalars['String'];
  lockersystemId?: InputMaybe<Scalars['ID']>;
  translation: Scalars['String'];
};

export type UpdateTranslationResponse = {
  __typename?: 'UpdateTranslationResponse';
  lockersystemId?: Maybe<Scalars['ID']>;
  translation?: Maybe<Translation>;
};

export type UpdateUser = {
  canUploadLockerPrograms?: InputMaybe<Scalars['Boolean']>;
  canViewCardKeys?: InputMaybe<Scalars['Boolean']>;
  canViewLockerPrograms?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  identityCode?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UpdateUserGroup = {
  lockersystemId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  userGroupId: Scalars['ID'];
};

export type UpdateUserGroupLockersystemPermission = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  role?: InputMaybe<LockersystemRole>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  userGroupLockersystemPermissionId: Scalars['ID'];
};

export type UpdateUserGroupLockersystemPermissionResponse = {
  __typename?: 'UpdateUserGroupLockersystemPermissionResponse';
  userGroupLockersystemPermission: UserGroupLockersystemPermission;
};

export type UpdateUserGroupResponse = {
  __typename?: 'UpdateUserGroupResponse';
  userGroup: UserGroup;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  user?: Maybe<User>;
};

export type UploadDoormap = {
  doormap: Scalars['String'];
  lockersystemId: Scalars['ID'];
};

export type UploadDoormapResponse = {
  __typename?: 'UploadDoormapResponse';
  lockersystem: Lockersystem;
  messages: Array<SetupFileMessage>;
};

export type UploadLockerProgram = {
  description?: InputMaybe<Scalars['String']>;
  originalFileName: Scalars['String'];
  payload: Scalars['String'];
};

export type UploadLockerProgramResponse = {
  __typename?: 'UploadLockerProgramResponse';
  lockerProgram?: Maybe<LockerProgram>;
};

export type UsageBucketRow = {
  __typename?: 'UsageBucketRow';
  bucketStart: Scalars['DateTime'];
  count: Scalars['Int'];
};

export enum UsageBucketSize {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH'
}

export type UsageBucketsQuery = {
  bucketSize: UsageBucketSize;
  end: Scalars['DateTime'];
  lockersystemId: Scalars['ID'];
  start: Scalars['DateTime'];
};

export type UsageBucketsResult = {
  __typename?: 'UsageBucketsResult';
  generatedAt: Scalars['DateTime'];
  rows: Array<UsageBucketRow>;
};

export type UsageOverview = {
  __typename?: 'UsageOverview';
  money?: Maybe<Scalars['Int']>;
  reservationCount?: Maybe<Scalars['Int']>;
  uniqueReservationsCount?: Maybe<Scalars['Int']>;
  uniqueUsersCount?: Maybe<Scalars['Int']>;
};

export type UsageOverviewOpt = {
  endDate: Scalars['DateTime'];
  lockersystemId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type UseLainaamoCodeResponse = {
  __typename?: 'UseLainaamoCodeResponse';
  success: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  accessCards: Array<AccessCard>;
  activeDeliveries: UserActiveDeliveriesConnection;
  activeRentings: UserActiveRentingsConnection;
  canUploadLockerPrograms: Scalars['Boolean'];
  canViewCardKeys: Scalars['Boolean'];
  canViewLockerPrograms: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  external?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  gmail?: Maybe<Scalars['String']>;
  hasAccessTo?: Maybe<Array<Maybe<Lockersystem>>>;
  id: Scalars['ID'];
  identityCode?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  lockerPermissions?: Maybe<Array<Maybe<UserLockerPermission>>>;
  lockersystemPermissions: Array<LockersystemUserPermission>;
  lockersystems: UserLockersystemsConnection;
  name?: Maybe<Scalars['String']>;
  passkeys: Array<Passkey>;
  resetToken?: Maybe<Scalars['String']>;
  resetUrl?: Maybe<Scalars['String']>;
  sessions: Array<UserSession>;
  signinType?: Maybe<SigninType>;
  ssn: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  userNotloginYet: Scalars['Boolean'];
};


export type UserAccessCardsArgs = {
  accesslistId?: InputMaybe<Scalars['ID']>;
};


export type UserLockerPermissionsArgs = {
  lockersystemId: Scalars['ID'];
};


export type UserLockersystemsArgs = {
  opt?: InputMaybe<UserLockersystemsOpt>;
};

export type UserActiveDeliveriesConnection = {
  __typename?: 'UserActiveDeliveriesConnection';
  deliveries: Array<Delivery>;
};

export type UserActiveRentingsConnection = {
  __typename?: 'UserActiveRentingsConnection';
  activeRentings: Array<Renting>;
  totalCount: Scalars['Int'];
};

export type UserDeliveriesConnection = {
  __typename?: 'UserDeliveriesConnection';
  deliveries: Array<Delivery>;
  totalCount: Scalars['Int'];
};

export type UserDoorcontrolPermission = {
  __typename?: 'UserDoorcontrolPermission';
  canCalibrateLockers: Scalars['Boolean'];
  canChangeNode: Scalars['Boolean'];
  canRemoteOpen: Scalars['Boolean'];
  canSendCardKeys: Scalars['Boolean'];
  canSendDoormap: Scalars['Boolean'];
  canSetHallTestMode: Scalars['Boolean'];
  canViewDoorState: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  doorcontrol: Doorcontrol;
  doorcontrolId: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID'];
  lockersystem?: Maybe<Lockersystem>;
  lockersystemId?: Maybe<Scalars['ID']>;
  lockersystemPermissions: Array<UserGroupLockersystemPermission>;
  name: Scalars['String'];
  users: Array<User>;
};

export type UserGroupLockersystemPermission = {
  __typename?: 'UserGroupLockersystemPermission';
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lockersystem: Lockersystem;
  lockersystemId: Scalars['ID'];
  role?: Maybe<LockersystemRole>;
  roleNumber: Scalars['Int'];
  startsAt?: Maybe<Scalars['DateTime']>;
  userGroupId: Scalars['ID'];
};

export type UserGroupUserInput = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UserLockerPermission = {
  __typename?: 'UserLockerPermission';
  id: Scalars['ID'];
  locker: Locker;
  lockerId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type UserLockersystemPermMod = {
  hasAccess: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type UserLockersystemsConnection = {
  __typename?: 'UserLockersystemsConnection';
  lockersystems: Array<Lockersystem>;
};

export type UserLockersystemsOpt = {
  deliveryAllowed?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  rentingAllowed?: InputMaybe<Scalars['Boolean']>;
};

export type UserSearchOptions = {
  accessToItemId?: InputMaybe<Scalars['ID']>;
  accessToLockerGroupId?: InputMaybe<Scalars['ID']>;
  accessToLockersystemId?: InputMaybe<Scalars['ID']>;
  hasEmail?: InputMaybe<Scalars['Boolean']>;
  searchWord?: InputMaybe<Scalars['String']>;
  showDenied?: InputMaybe<Scalars['Boolean']>;
  showNotLoggedIn?: InputMaybe<Scalars['Boolean']>;
  signinType?: InputMaybe<SigninType>;
  withoutAccessToLockersystemId?: InputMaybe<Scalars['ID']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  absoluteExpiresAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  idleExpiresAt: Scalars['DateTime'];
  ipAddress?: Maybe<Scalars['String']>;
  lastUsedAt: Scalars['DateTime'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  revokedReason?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  totalCount?: Maybe<Scalars['Int']>;
  users: Array<User>;
};

export type Validation = {
  __typename?: 'Validation';
  areaId?: Maybe<Scalars['ID']>;
  cardnumber?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  gateId?: Maybe<Scalars['ID']>;
  nodeId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  validationDirection?: Maybe<ValidationDirection>;
  validationErrorCode?: Maybe<Scalars['Int']>;
  validationType?: Maybe<ValidationType>;
};

export enum ValidationDirection {
  In = 'In',
  None = 'None',
  Out = 'Out'
}

export enum ValidationErrorCode {
  CardFailure = 'CardFailure',
  CustomerIsRequired = 'CustomerIsRequired',
  CustomerNotFound = 'CustomerNotFound',
  CustomerNotValidNow = 'CustomerNotValidNow',
  Expired = 'Expired',
  LocationAccessDenided = 'LocationAccessDenided',
  NoCardInReader = 'NoCardInReader',
  NoMultivalidation = 'NoMultivalidation',
  NoPeriodValidationRemaining = 'NoPeriodValidationRemaining',
  NoProductsInCard = 'NoProductsInCard',
  NotCurrentlyValid = 'NotCurrentlyValid',
  NotEnoughValue = 'NotEnoughValue',
  NotYetValid = 'NotYetValid',
  PriceNotFound = 'PriceNotFound',
  ProductIsOnReceipt = 'ProductIsOnReceipt',
  ProductUseNotAllowedByParameters = 'ProductUseNotAllowedByParameters',
  ProductUseTimeLimitation = 'ProductUseTimeLimitation',
  ProductZonesNotValid = 'ProductZonesNotValid',
  Unknow = 'Unknow',
  UnknowProduct = 'UnknowProduct',
  WeekDayAccessDenied = 'WeekDayAccessDenied'
}

export enum ValidationType {
  Backvalidation = 'Backvalidation',
  FreepassCard = 'FreepassCard',
  FreepassRemote = 'FreepassRemote',
  None = 'None',
  Normal = 'Normal',
  NormalOut = 'NormalOut'
}

export type Viewer = {
  __typename?: 'Viewer';
  canManagePasskeys: Scalars['Boolean'];
  featureFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
  passkeys: Array<Passkey>;
  portalAddress?: Maybe<Scalars['String']>;
  portalOauthClientId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type VisitorCountsQuery = {
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  datetimePoints?: InputMaybe<Array<Scalars['DateTime']>>;
  nodeIds?: InputMaybe<Array<Scalars['String']>>;
  productId?: InputMaybe<Array<Scalars['String']>>;
};

export type VisitorQueryResult = {
  __typename?: 'VisitorQueryResult';
  dataPoints: Array<DatetimeDataPoint>;
  totalInCount: Scalars['Int'];
  totalOutCount: Scalars['Int'];
};

export type SetupUser = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lockersystemAdmin?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};
